// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes opacity-show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes opacity-hide {
  100% {
    opacity: 0;
  }
}
:root {
  --swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);
  --swal2-container-padding: 0.625em;
  --swal2-backdrop: rgba(0, 0, 0, 0.4);
  --swal2-backdrop-transition: background-color 0.1s;
  --swal2-width: 32em;
  --swal2-padding: 0 0 1.25em;
  --swal2-border: none;
  --swal2-border-radius: 0.3125rem;
  --swal2-background: white;
  --swal2-color: #545454;
  --swal2-footer-border-color: #eee;
  --swal2-show-animation: swal2-show 0.3s;
  --swal2-hide-animation: swal2-hide 0.15s forwards;
  --swal2-icon-zoom: 1;
  --swal2-icon-animations: true;
  --swal2-title-padding: 0.8em 1em 0;
  --swal2-html-container-padding: 1em 1.6em 0.3em;
  --swal2-input-border-radius: 0.1875em;
  --swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;
  --swal2-input-background: transparent;
  --swal2-input-transition: border-color 0.2s, box-shadow 0.2s;
  --swal2-progress-step-background: #add8e6;
  --swal2-validation-message-background: #f0f0f0;
  --swal2-validation-message-color: #666;
  --swal2-close-button-position: initial;
  --swal2-close-button-inset: auto;
  --swal2-close-button-font-size: 2.5em;
  --swal2-close-button-color: #ccc;
  --swal2-close-button-transition: color 0.2s, box-shadow 0.2s;
  --swal2-close-button-outline: initial;
  --swal2-close-button-box-shadow: inset 0 0 0 3px transparent;
  --swal2-close-button-focus-box-shadow: inset var(--swal2-outline);
  --swal2-close-button-hover-transform: none;
  --swal2-button-transition: background-color 0.2s, box-shadow 0.2s;
  --swal2-confirm-button-border: 0;
  --swal2-confirm-button-border-radius: 0.25em;
  --swal2-confirm-button-background-color: #7066e0;
  --swal2-confirm-button-color: #fff;
  --swal2-deny-button-border: 0;
  --swal2-deny-button-border-radius: 0.25em;
  --swal2-deny-button-background-color: #dc3741;
  --swal2-deny-button-color: #fff;
  --swal2-cancel-button-border: 0;
  --swal2-cancel-button-border-radius: 0.25em;
  --swal2-cancel-button-background-color: #6e7881;
  --swal2-cancel-button-color: #fff;
  --swal2-toast-show-animation: swal2-toast-show 0.5s;
  --swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;
  --swal2-toast-border: none;
  --swal2-toast-box-shadow:
    0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075),
    1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075);
}

[data-swal2-theme=dark] {
  --swal2-dark-theme-black: #19191a;
  --swal2-dark-theme-white: #e1e1e1;
  --swal2-background: var(--swal2-dark-theme-black);
  --swal2-color: var(--swal2-dark-theme-white);
  --swal2-footer-border-color: #555;
  --swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);
  --swal2-validation-message-background: color-mix(
    in srgb,
    var(--swal2-dark-theme-black),
    var(--swal2-dark-theme-white) 10%
  );
  --swal2-validation-message-color: var(--swal2-dark-theme-white);
}

@media (prefers-color-scheme: dark) {
  [data-swal2-theme=auto] {
    --swal2-dark-theme-black: #19191a;
    --swal2-dark-theme-white: #e1e1e1;
    --swal2-background: var(--swal2-dark-theme-black);
    --swal2-color: var(--swal2-dark-theme-white);
    --swal2-footer-border-color: #555;
    --swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);
    --swal2-validation-message-background: color-mix(
      in srgb,
      var(--swal2-dark-theme-black),
      var(--swal2-dark-theme-white) 10%
    );
    --swal2-validation-message-color: var(--swal2-dark-theme-white);
  }
}
body.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) {
  overflow: hidden;
}
body.swal2-height-auto {
  height: auto !important;
}
body.swal2-no-backdrop .swal2-container {
  background-color: transparent !important;
  pointer-events: none;
}
body.swal2-no-backdrop .swal2-container .swal2-popup {
  pointer-events: all;
}
body.swal2-no-backdrop .swal2-container .swal2-modal {
  box-shadow: 0 0 10px rgba(54, 70, 93, 0.99);
}
body.swal2-toast-shown .swal2-container {
  box-sizing: border-box;
  width: 360px;
  max-width: 100%;
  background-color: transparent;
  pointer-events: none;
}
body.swal2-toast-shown .swal2-container.swal2-top {
  inset: 0 auto auto 50%;
  transform: translateX(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {
  inset: 0 0 auto auto;
}
body.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {
  inset: 0 auto auto 0;
}
body.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {
  inset: 50% auto auto 0;
  transform: translateY(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-center {
  inset: 50% auto auto 50%;
  transform: translate(-50%, -50%);
}
body.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {
  inset: 50% 0 auto auto;
  transform: translateY(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {
  inset: auto auto 0 0;
}
body.swal2-toast-shown .swal2-container.swal2-bottom {
  inset: auto auto 0 50%;
  transform: translateX(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {
  inset: auto 0 0 auto;
}
@media print {
  body.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) {
    overflow-y: scroll !important;
  }
  body.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) > [aria-hidden=true] {
    display: none;
  }
  body.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) .swal2-container {
    position: static !important;
  }
}

div:where(.swal2-container) {
  display: grid;
  position: fixed;
  z-index: 1060;
  inset: 0;
  box-sizing: border-box;
  grid-template-areas: "top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";
  grid-template-rows: minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);
  height: 100%;
  padding: var(--swal2-container-padding);
  overflow-x: hidden;
  transition: var(--swal2-backdrop-transition);
  -webkit-overflow-scrolling: touch;
}
div:where(.swal2-container).swal2-backdrop-show, div:where(.swal2-container).swal2-noanimation {
  background: rgba(54, 70, 93, 0.99);
}
div:where(.swal2-container).swal2-backdrop-hide {
  background: transparent !important;
}
div:where(.swal2-container).swal2-top-start, div:where(.swal2-container).swal2-center-start, div:where(.swal2-container).swal2-bottom-start {
  grid-template-columns: minmax(0, 1fr) auto auto;
}
div:where(.swal2-container).swal2-top, div:where(.swal2-container).swal2-center, div:where(.swal2-container).swal2-bottom {
  grid-template-columns: auto minmax(0, 1fr) auto;
}
div:where(.swal2-container).swal2-top-end, div:where(.swal2-container).swal2-center-end, div:where(.swal2-container).swal2-bottom-end {
  grid-template-columns: auto auto minmax(0, 1fr);
}
div:where(.swal2-container).swal2-top-start > .swal2-popup {
  align-self: start;
}
div:where(.swal2-container).swal2-top > .swal2-popup {
  grid-column: 2;
  place-self: start center;
}
div:where(.swal2-container).swal2-top-end > .swal2-popup, div:where(.swal2-container).swal2-top-right > .swal2-popup {
  grid-column: 3;
  place-self: start end;
}
div:where(.swal2-container).swal2-center-start > .swal2-popup, div:where(.swal2-container).swal2-center-left > .swal2-popup {
  grid-row: 2;
  align-self: center;
}
div:where(.swal2-container).swal2-center > .swal2-popup {
  grid-column: 2;
  grid-row: 2;
  place-self: center center;
}
div:where(.swal2-container).swal2-center-end > .swal2-popup, div:where(.swal2-container).swal2-center-right > .swal2-popup {
  grid-column: 3;
  grid-row: 2;
  place-self: center end;
}
div:where(.swal2-container).swal2-bottom-start > .swal2-popup, div:where(.swal2-container).swal2-bottom-left > .swal2-popup {
  grid-column: 1;
  grid-row: 3;
  align-self: end;
}
div:where(.swal2-container).swal2-bottom > .swal2-popup {
  grid-column: 2;
  grid-row: 3;
  place-self: end center;
}
div:where(.swal2-container).swal2-bottom-end > .swal2-popup, div:where(.swal2-container).swal2-bottom-right > .swal2-popup {
  grid-column: 3;
  grid-row: 3;
  place-self: end end;
}
div:where(.swal2-container).swal2-grow-row > .swal2-popup, div:where(.swal2-container).swal2-grow-fullscreen > .swal2-popup {
  grid-column: 1/4;
  width: 100%;
}
div:where(.swal2-container).swal2-grow-column > .swal2-popup, div:where(.swal2-container).swal2-grow-fullscreen > .swal2-popup {
  grid-row: 1/4;
  align-self: stretch;
}
div:where(.swal2-container).swal2-no-transition {
  transition: none !important;
}
div:where(.swal2-container)[popover] {
  width: auto;
  border: 0;
}
div:where(.swal2-container) div:where(.swal2-popup) {
  display: none;
  position: relative;
  box-sizing: border-box;
  grid-template-columns: minmax(0, 100%);
  width: var(--swal2-width);
  max-width: 100%;
  padding: var(--swal2-padding);
  border: var(--swal2-border);
  border-radius: var(--swal2-border-radius);
  background: transparent;
  color: var(--swal2-color);
  font-family: inherit;
  font-size: 1rem;
  container-name: swal2-popup;
}
div:where(.swal2-container) div:where(.swal2-popup):focus {
  outline: none;
}
div:where(.swal2-container) div:where(.swal2-popup).swal2-loading {
  overflow-y: hidden;
}
div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable {
  cursor: grab;
}
div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon) {
  cursor: grab;
}
div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging {
  cursor: grabbing;
}
div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon) {
  cursor: grabbing;
}
div:where(.swal2-container) h2:where(.swal2-title) {
  position: relative;
  max-width: 100%;
  margin: 0;
  padding: var(--swal2-title-padding);
  color: #fff;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
  cursor: initial;
}
div:where(.swal2-container) div:where(.swal2-actions) {
  display: flex;
  z-index: 1;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: auto;
  margin: 1.25em auto 0;
  padding: 0;
}
div:where(.swal2-container) div:where(.swal2-loader) {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2.2em;
  height: 2.2em;
  margin: 0 1.875em;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border-width: 0.25em;
  border-style: solid;
  border-radius: 100%;
  border-color: #2778c4 transparent #2778c4 transparent;
}
div:where(.swal2-container) button:where(.swal2-styled) {
  margin: 0.3125em;
  padding: 0.625em 1.1em;
  transition: var(--swal2-button-transition);
  box-shadow: 0 0 0 3px transparent;
  font-weight: 500;
}
div:where(.swal2-container) button:where(.swal2-styled):not([disabled]) {
  cursor: pointer;
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm) {
  border: var(--swal2-confirm-button-border);
  border-radius: var(--swal2-confirm-button-border-radius);
  background: initial;
  background-color: var(--swal2-confirm-button-background-color);
  color: var(--swal2-confirm-button-color);
  font-size: 1em;
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover {
  background-color: color-mix(in srgb, var(--swal2-confirm-button-background-color), black 10%);
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active {
  background-color: color-mix(in srgb, var(--swal2-confirm-button-background-color), black 20%);
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny) {
  border: var(--swal2-deny-button-border);
  border-radius: var(--swal2-deny-button-border-radius);
  background: initial;
  background-color: var(--swal2-deny-button-background-color);
  color: var(--swal2-deny-button-color);
  font-size: 1em;
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover {
  background-color: color-mix(in srgb, var(--swal2-deny-button-background-color), black 10%);
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active {
  background-color: color-mix(in srgb, var(--swal2-deny-button-background-color), black 20%);
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel) {
  border: var(--swal2-cancel-button-border);
  border-radius: var(--swal2-cancel-button-border-radius);
  background: initial;
  background-color: var(--swal2-cancel-button-background-color);
  color: var(--swal2-cancel-button-color);
  font-size: 1em;
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover {
  background-color: color-mix(in srgb, var(--swal2-cancel-button-background-color), black 10%);
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active {
  background-color: color-mix(in srgb, var(--swal2-cancel-button-background-color), black 20%);
}
div:where(.swal2-container) button:where(.swal2-styled):focus-visible {
  outline: none;
  box-shadow: var(--swal2-action-button-outline);
}
div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading) {
  opacity: 0.4;
}
div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner {
  border: 0;
}
div:where(.swal2-container) div:where(.swal2-footer) {
  margin: 1em 0 0;
  padding: 1em 1em 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 1em;
  text-align: center;
  cursor: initial;
}
div:where(.swal2-container) .swal2-timer-progress-bar-container {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  grid-column: auto !important;
  overflow: hidden;
  border-bottom-right-radius: var(--swal2-border-radius);
  border-bottom-left-radius: var(--swal2-border-radius);
}
div:where(.swal2-container) div:where(.swal2-timer-progress-bar) {
  width: 100%;
  height: 0.25em;
  background: rgba(0, 0, 0, 0.2);
}
div:where(.swal2-container) img:where(.swal2-image) {
  max-width: 100%;
  margin: 2em auto 1em;
  cursor: initial;
}
div:where(.swal2-container) button:where(.swal2-close) {
  position: fixed;
  inset: var(--swal2-close-button-inset);
  z-index: 2;
  align-items: center;
  justify-content: center;
  width: 1.2em;
  height: 1.2em;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: -1.2em;
  padding: 0;
  overflow: hidden;
  transition: var(--swal2-close-button-transition);
  border: none;
  border-radius: var(--swal2-border-radius);
  outline: var(--swal2-close-button-outline);
  background: transparent;
  color: #fff;
  font-family: monospace;
  font-size: 3em;
  cursor: pointer;
  justify-self: end;
}
div:where(.swal2-container) button:where(.swal2-close):hover {
  transform: var(--swal2-close-button-hover-transform);
  background: transparent;
  color: #f27474;
}
div:where(.swal2-container) button:where(.swal2-close):focus-visible {
  outline: none;
  box-shadow: var(--swal2-close-button-focus-box-shadow);
}
div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner {
  border: 0;
}
div:where(.swal2-container) div:where(.swal2-html-container) {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: var(--swal2-html-container-padding);
  overflow: auto;
  color: #fff;
  font-size: 1.125em;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
  word-break: break-word;
  cursor: initial;
}
div:where(.swal2-container) input:where(.swal2-input),
div:where(.swal2-container) input:where(.swal2-file),
div:where(.swal2-container) textarea:where(.swal2-textarea),
div:where(.swal2-container) select:where(.swal2-select),
div:where(.swal2-container) div:where(.swal2-radio),
div:where(.swal2-container) label:where(.swal2-checkbox) {
  margin: 1em 2em 3px;
}
div:where(.swal2-container) input:where(.swal2-input),
div:where(.swal2-container) input:where(.swal2-file),
div:where(.swal2-container) textarea:where(.swal2-textarea) {
  box-sizing: border-box;
  width: auto;
  transition: var(--swal2-input-transition);
  border: 1px solid #d9d9d9;
  border-radius: var(--swal2-input-border-radius);
  background: rgba(73, 94, 125, 0.99);
  box-shadow: var(--swal2-input-box-shadow);
  color: #fff;
  font-size: 1.125em;
}
div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,
div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,
div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror {
  border-color: #f27474 !important;
  box-shadow: 0 0 2px #f27474 !important;
}
div:where(.swal2-container) input:where(.swal2-input):focus,
div:where(.swal2-container) input:where(.swal2-file):focus,
div:where(.swal2-container) textarea:where(.swal2-textarea):focus {
  border: 1px solid #b4dbed;
  outline: none;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);
}
div:where(.swal2-container) input:where(.swal2-input)::placeholder,
div:where(.swal2-container) input:where(.swal2-file)::placeholder,
div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder {
  color: #ccc;
}
div:where(.swal2-container) .swal2-range {
  margin: 1em 2em 3px;
  background: transparent;
}
div:where(.swal2-container) .swal2-range input {
  width: 80%;
}
div:where(.swal2-container) .swal2-range output {
  width: 20%;
  color: #fff;
  font-weight: 600;
  text-align: center;
}
div:where(.swal2-container) .swal2-range input,
div:where(.swal2-container) .swal2-range output {
  height: 2.625em;
  padding: 0;
  font-size: 1.125em;
  line-height: 2.625em;
}
div:where(.swal2-container) .swal2-input {
  height: 2.625em;
  padding: 0 0.75em;
}
div:where(.swal2-container) .swal2-file {
  width: 75%;
  margin-right: auto;
  margin-left: auto;
  background: rgba(73, 94, 125, 0.99);
  font-size: 1.125em;
}
div:where(.swal2-container) .swal2-textarea {
  height: 6.75em;
  padding: 0.75em;
}
div:where(.swal2-container) .swal2-select {
  min-width: 50%;
  max-width: 100%;
  padding: 0.375em 0.625em;
  background: rgba(73, 94, 125, 0.99);
  color: #fff;
  font-size: 1.125em;
}
div:where(.swal2-container) .swal2-radio,
div:where(.swal2-container) .swal2-checkbox {
  align-items: center;
  justify-content: center;
  background: transparent;
  color: #fff;
}
div:where(.swal2-container) .swal2-radio label,
div:where(.swal2-container) .swal2-checkbox label {
  margin: 0 0.6em;
  font-size: 1.125em;
}
div:where(.swal2-container) .swal2-radio input,
div:where(.swal2-container) .swal2-checkbox input {
  flex-shrink: 0;
  margin: 0 0.4em;
}
div:where(.swal2-container) label:where(.swal2-input-label) {
  display: flex;
  justify-content: center;
  margin: 1em auto 0;
}
div:where(.swal2-container) div:where(.swal2-validation-message) {
  align-items: center;
  justify-content: center;
  margin: 1em 0 0;
  padding: 0.625em;
  overflow: hidden;
  background: transparent;
  color: #fff;
  font-size: 1em;
  font-weight: 300;
}
div:where(.swal2-container) div:where(.swal2-validation-message)::before {
  content: "!";
  display: inline-block;
  width: 1.5em;
  min-width: 1.5em;
  height: 1.5em;
  margin: 0 0.625em;
  border-radius: 50%;
  background-color: #f27474;
  color: #fff;
  font-weight: 600;
  line-height: 1.5em;
  text-align: center;
}
div:where(.swal2-container) .swal2-progress-steps {
  flex-wrap: wrap;
  align-items: center;
  max-width: 100%;
  margin: 1.25em auto;
  padding: 0;
  background: transparent;
  font-weight: 600;
}
div:where(.swal2-container) .swal2-progress-steps li {
  display: inline-block;
  position: relative;
}
div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step {
  z-index: 20;
  flex-shrink: 0;
  width: 2em;
  height: 2em;
  border-radius: 2em;
  background: #2778c4;
  color: #fff;
  line-height: 2em;
  text-align: center;
}
div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #2778c4;
}
div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step {
  background: rgba(122, 145, 178, 0.99);
  color: #fff;
}
div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(122, 145, 178, 0.99);
}
div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line {
  z-index: 10;
  flex-shrink: 0;
  width: 2.5em;
  height: 0.4em;
  margin: 0 -1px;
  background: #2778c4;
}

div:where(.swal2-icon) {
  position: relative;
  box-sizing: content-box;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: 2.5em auto 0.6em;
  zoom: var(--swal2-icon-zoom);
  border: 0.25em solid transparent;
  border-radius: 50%;
  border-color: #000;
  font-family: inherit;
  line-height: 5em;
  cursor: default;
  user-select: none;
}
div:where(.swal2-icon) .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 3.75em;
}
div:where(.swal2-icon).swal2-error {
  border-color: #f27474;
  color: #f27474;
}
div:where(.swal2-icon).swal2-error .swal2-x-mark {
  position: relative;
  flex-grow: 1;
}
div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line] {
  display: block;
  position: absolute;
  top: 2.3125em;
  width: 2.9375em;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #f27474;
}
div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 1.0625em;
  transform: rotate(45deg);
}
div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 1em;
  transform: rotate(-45deg);
}
@container swal2-popup style(--swal2-icon-animations:true) {
  div:where(.swal2-icon).swal2-error.swal2-icon-show {
    animation: swal2-animate-error-icon 0.5s;
  }
  div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark {
    animation: swal2-animate-error-x-mark 0.5s;
  }
}
div:where(.swal2-icon).swal2-warning {
  border-color: #f8bb86;
  color: #f8bb86;
}
@container swal2-popup style(--swal2-icon-animations:true) {
  div:where(.swal2-icon).swal2-warning.swal2-icon-show {
    animation: swal2-animate-error-icon 0.5s;
  }
  div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content {
    animation: swal2-animate-i-mark 0.5s;
  }
}
div:where(.swal2-icon).swal2-info {
  border-color: #3fc3ee;
  color: #3fc3ee;
}
@container swal2-popup style(--swal2-icon-animations:true) {
  div:where(.swal2-icon).swal2-info.swal2-icon-show {
    animation: swal2-animate-error-icon 0.5s;
  }
  div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content {
    animation: swal2-animate-i-mark 0.8s;
  }
}
div:where(.swal2-icon).swal2-question {
  border-color: #87adbd;
  color: #87adbd;
}
@container swal2-popup style(--swal2-icon-animations:true) {
  div:where(.swal2-icon).swal2-question.swal2-icon-show {
    animation: swal2-animate-error-icon 0.5s;
  }
  div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content {
    animation: swal2-animate-question-mark 0.8s;
  }
}
div:where(.swal2-icon).swal2-success {
  border-color: #a5dc86;
  color: #a5dc86;
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  border-radius: 50%;
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.4375em;
  left: -2.0635em;
  transform: rotate(-45deg);
  transform-origin: 3.75em 3.75em;
  border-radius: 7.5em 0 0 7.5em;
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0;
}
div:where(.swal2-icon).swal2-success .swal2-success-ring {
  position: absolute;
  z-index: 2;
  top: -0.25em;
  left: -0.25em;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  border: 0.25em solid rgba(165, 220, 134, 0.3);
  border-radius: 50%;
}
div:where(.swal2-icon).swal2-success .swal2-success-fix {
  position: absolute;
  z-index: 1;
  top: 0.5em;
  left: 1.625em;
  width: 0.4375em;
  height: 5.625em;
  transform: rotate(-45deg);
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-line] {
  display: block;
  position: absolute;
  z-index: 2;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #a5dc86;
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 2.875em;
  left: 0.8125em;
  width: 1.5625em;
  transform: rotate(45deg);
}
div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class\$=long] {
  top: 2.375em;
  right: 0.5em;
  width: 2.9375em;
  transform: rotate(-45deg);
}
@container swal2-popup style(--swal2-icon-animations:true) {
  div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip {
    animation: swal2-animate-success-line-tip 0.75s;
  }
  div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long {
    animation: swal2-animate-success-line-long 0.75s;
  }
  div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right {
    animation: swal2-rotate-success-circular-line 4.25s ease-in;
  }
}

[class^=swal2] {
  -webkit-tap-highlight-color: transparent;
}

.swal2-show {
  animation: opacity-show 0.3s;
}

.swal2-hide {
  animation: opacity-hide 0.1s;
}

.swal2-noanimation {
  transition: none;
}

.swal2-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

.swal2-rtl .swal2-close {
  margin-right: initial;
  margin-left: 0;
}
.swal2-rtl .swal2-timer-progress-bar {
  right: 0;
  left: auto;
}

.swal2-toast {
  box-sizing: border-box;
  grid-column: 1/4 !important;
  grid-row: 1/4 !important;
  grid-template-columns: min-content auto min-content;
  padding: 1em;
  overflow-y: hidden;
  border: var(--swal2-toast-border);
  background: rgba(54, 70, 93, 0.99);
  box-shadow: var(--swal2-toast-box-shadow);
  pointer-events: all;
}
.swal2-toast > * {
  grid-column: 2;
}
.swal2-toast h2:where(.swal2-title) {
  margin: 0.5em 1em;
  padding: 0;
  font-size: 1em;
  text-align: initial;
}
.swal2-toast .swal2-loading {
  justify-content: center;
}
.swal2-toast input:where(.swal2-input) {
  height: 2em;
  margin: 0.5em;
  font-size: 1em;
}
.swal2-toast .swal2-validation-message {
  font-size: 1em;
}
.swal2-toast div:where(.swal2-footer) {
  margin: 0.5em 0 0;
  padding: 0.5em 0 0;
  font-size: 0.8em;
}
.swal2-toast button:where(.swal2-close) {
  grid-column: 3/3;
  grid-row: 1/99;
  align-self: center;
  width: 0.8em;
  height: 0.8em;
  margin: 0;
  font-size: 2em;
}
.swal2-toast div:where(.swal2-html-container) {
  margin: 0.5em 1em;
  padding: 0;
  overflow: initial;
  font-size: 1em;
  text-align: initial;
}
.swal2-toast div:where(.swal2-html-container):empty {
  padding: 0;
}
.swal2-toast .swal2-loader {
  grid-column: 1;
  grid-row: 1/99;
  align-self: center;
  width: 2em;
  height: 2em;
  margin: 0.25em;
}
.swal2-toast .swal2-icon {
  grid-column: 1;
  grid-row: 1/99;
  align-self: center;
  width: 2em;
  min-width: 2em;
  height: 2em;
  margin: 0 0.5em 0 0;
}
.swal2-toast .swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 1.8em;
  font-weight: bold;
}
.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}
.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  top: 0.875em;
  width: 1.375em;
}
.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 0.3125em;
}
.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 0.3125em;
}
.swal2-toast div:where(.swal2-actions) {
  justify-content: flex-start;
  height: auto;
  margin: 0;
  margin-top: 0.5em;
  padding: 0 0.5em;
}
.swal2-toast button:where(.swal2-styled) {
  margin: 0.25em 0.5em;
  padding: 0.4em 0.6em;
  font-size: 1em;
}
.swal2-toast .swal2-success {
  border-color: #a5dc86;
}
.swal2-toast .swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 1.6em;
  height: 3em;
  border-radius: 50%;
}
.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.8em;
  left: -0.5em;
  transform: rotate(-45deg);
  transform-origin: 2em 2em;
  border-radius: 4em 0 0 4em;
}
.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.25em;
  left: 0.9375em;
  transform-origin: 0 1.5em;
  border-radius: 0 4em 4em 0;
}
.swal2-toast .swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}
.swal2-toast .swal2-success .swal2-success-fix {
  top: 0;
  left: 0.4375em;
  width: 0.4375em;
  height: 2.6875em;
}
.swal2-toast .swal2-success [class^=swal2-success-line] {
  height: 0.3125em;
}
.swal2-toast .swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 1.125em;
  left: 0.1875em;
  width: 0.75em;
}
.swal2-toast .swal2-success [class^=swal2-success-line][class\$=long] {
  top: 0.9375em;
  right: 0.1875em;
  width: 1.375em;
}
@container swal2-popup style(--swal2-icon-animations:true) {
  .swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip {
    animation: swal2-toast-animate-success-line-tip 0.75s;
  }
  .swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long {
    animation: swal2-toast-animate-success-line-long 0.75s;
  }
}
.swal2-toast.swal2-show {
  animation: var(--swal2-toast-show-animation);
}
.swal2-toast.swal2-hide {
  animation: var(--swal2-toast-hide-animation);
}

@keyframes swal2-show {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes swal2-hide {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}
@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 1.0625em;
    left: 0.125em;
    width: 0;
  }
  70% {
    top: 2.1875em;
    left: -0.375em;
    width: 3.125em;
  }
  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em;
  }
  100% {
    top: 2.8125em;
    left: 0.8125em;
    width: 1.5625em;
  }
}
@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em;
  }
  100% {
    top: 2.375em;
    right: 0.5em;
    width: 2.9375em;
  }
}
@keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  50% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  80% {
    margin-top: -0.375em;
    transform: scale(1.15);
  }
  100% {
    margin-top: 0;
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes swal2-animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
@keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes swal2-animate-question-mark {
  0% {
    transform: rotateY(-360deg);
  }
  100% {
    transform: rotateY(0);
  }
}
@keyframes swal2-animate-i-mark {
  0% {
    transform: rotateZ(45deg);
    opacity: 0;
  }
  25% {
    transform: rotateZ(-25deg);
    opacity: 0.4;
  }
  50% {
    transform: rotateZ(15deg);
    opacity: 0.8;
  }
  75% {
    transform: rotateZ(-5deg);
    opacity: 1;
  }
  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}
@keyframes swal2-toast-show {
  0% {
    transform: translateY(-0.625em) rotateZ(2deg);
  }
  33% {
    transform: translateY(0) rotateZ(-2deg);
  }
  66% {
    transform: translateY(0.3125em) rotateZ(2deg);
  }
  100% {
    transform: translateY(0) rotateZ(0deg);
  }
}
@keyframes swal2-toast-hide {
  100% {
    transform: rotateZ(1deg);
    opacity: 0;
  }
}
@keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: 0.5625em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 0.125em;
    left: 0.125em;
    width: 0;
  }
  70% {
    top: 0.625em;
    left: -0.25em;
    width: 1.625em;
  }
  84% {
    top: 1.0625em;
    left: 0.75em;
    width: 0.5em;
  }
  100% {
    top: 1.125em;
    left: 0.1875em;
    width: 0.75em;
  }
}
@keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em;
    right: 1.375em;
    width: 0;
  }
  65% {
    top: 1.25em;
    right: 0.9375em;
    width: 0;
  }
  84% {
    top: 0.9375em;
    right: 0;
    width: 1.125em;
  }
  100% {
    top: 0.9375em;
    right: 0.1875em;
    width: 1.375em;
  }
}
.swal2-container {
  font-family: GameFont;
}

a {
  color: var(--swal2-confirm-button-color);
}`, "",{"version":3,"sources":["webpack://./node_modules/@sweetalert2/themes/borderless/borderless.scss","webpack://./module/libs/sweetalert/style.scss","webpack://./node_modules/sweetalert2/src/sweetalert2.scss"],"names":[],"mappings":"AAYA;EACE;IAAK,UAAA;ECVL;EDWA;IAAO,UAAA;ECRP;AACF;ADUA;EACE;IAAO,UAAA;ECPP;AACF;ACRA;EACE,mDAAA;EAGA,kCAAA;EAGA,oCAAA;EACA,kDAAA;EAGA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,gCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iCAAA;EAGA,uCAAA;EACA,iDAAA;EAGA,oBAAA;EACA,6BAAA;EAGA,kCAAA;EAGA,+CAAA;EAGA,qCAAA;EACA,oFAAA;EACA,qCAAA;EACA,4DAAA;EAGA,yCAAA;EAGA,8CAAA;EACA,sCAAA;EAGA,sCAAA;EACA,gCAAA;EACA,qCAAA;EACA,gCAAA;EACA,4DAAA;EACA,qCAAA;EACA,4DAAA;EACA,iEAAA;EAGA,0CAAA;EAGA,iEAAA;EAGA,gCAAA;EACA,4CAAA;EACA,gDAAA;EACA,kCAAA;EAGA,6BAAA;EACA,yCAAA;EACA,6CAAA;EACA,+BAAA;EAGA,+BAAA;EACA,2CAAA;EACA,+CAAA;EACA,iCAAA;EAGA,mDAAA;EACA,4DAAA;EACA,0BAAA;EACA;;6EAAA;ADtBF;;ACiDA;EApBE,iCAAA;EACA,iCAAA;EAGA,iDAAA;EACA,4CAAA;EACA,iCAAA;EAGA,8GAAA;EAGA;;;;GAAA;EAKA,+DAAA;AD/BF;;ACuCA;EACE;IA1BA,iCAAA;IACA,iCAAA;IAGA,iDAAA;IACA,4CAAA;IACA,iCAAA;IAGA,8GAAA;IAGA;;;;KAAA;IAKA,+DAAA;EDfA;AACF;ACiRE;EACE,gBAAA;AD/QJ;ACkRE;EACE,uBAAA;ADhRJ;ACoRI;EACE,wCAAA;EACA,oBAAA;ADlRN;ACoRM;EACE,mBAAA;ADlRR;ACqRM;EACE,2CAAA;ADnRR;AC0RI;EACE,sBAAA;EACA,YA/Cc;EAgDd,eAAA;EACA,6BAAA;EACA,oBAAA;ADxRN;AC0RM;EACE,sBAAA;EACA,2BAAA;ADxRR;AC2RM;EAEE,oBAAA;AD1RR;AC6RM;EAEE,oBAAA;AD5RR;AC+RM;EAEE,sBAAA;EACA,2BAAA;AD9RR;ACiSM;EACE,wBAAA;EACA,gCAAA;AD/RR;ACkSM;EAEE,sBAAA;EACA,2BAAA;ADjSR;ACoSM;EAEE,oBAAA;ADnSR;ACsSM;EACE,sBAAA;EACA,2BAAA;ADpSR;ACuSM;EAEE,oBAAA;ADtSR;AC4SE;EACE;IACE,6BAAA;ED1SJ;EC4SI;IACE,aAAA;ED1SN;EC6SI;IACE,2BAAA;ED3SN;AACF;;ACiTA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,+IACE;EAGF,iGAAA;EACA,YAAA;EACA,uCAhWwB;EAiWxB,kBAAA;EACA,4CA9V0B;EAiW1B,iCAAA;ADnTF;ACqTE;EAEE,kCF1eqB;ACsLzB;ACuTE;EACE,kCAAA;ADrTJ;ACwTE;EAGE,+CAAA;ADxTJ;AC2TE;EAGE,+CAAA;AD3TJ;AC8TE;EAGE,+CAAA;AD9TJ;ACiUE;EACE,iBAAA;AD/TJ;ACkUE;EACE,cAAA;EACA,wBAAA;ADhUJ;ACmUE;EAEE,cAAA;EACA,qBAAA;ADlUJ;ACqUE;EAEE,WAAA;EACA,kBAAA;ADpUJ;ACuUE;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ADrUJ;ACwUE;EAEE,cAAA;EACA,WAAA;EACA,sBAAA;ADvUJ;AC0UE;EAEE,cAAA;EACA,WAAA;EACA,eAAA;ADzUJ;AC4UE;EACE,cAAA;EACA,WAAA;EACA,sBAAA;AD1UJ;AC6UE;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;AD5UJ;AC+UE;EAEE,gBAAA;EACA,WAAA;AD9UJ;ACiVE;EAEE,aAAA;EACA,mBAAA;ADhVJ;ACmVE;EACE,2BAAA;ADjVJ;ACoVE;EACE,WAAA;EACA,SAAA;ADlVJ;ACqVE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,yBA3cU;EA4cV,eAAA;EACA,6BA5cY;EA6cZ,2BA5cW;EA6cX,yCA5ckB;EA6clB,uBFlkBe;EEmkBf,yBA5cU;EA6cV,oBAtcS;EAucT,eAtcc;EAucd,2BAAA;ADnVJ;ACqVI;EACE,aAAA;ADnVN;ACsVI;EACE,kBAAA;ADpVN;ACuVI;EACE,YAAA;ADrVN;ACuVM;EACE,YAAA;ADrVR;ACyVI;EACE,gBAAA;ADvVN;ACyVM;EACE,gBAAA;ADvVR;AC4VE;EACE,kBA/cmB;EAgdnB,eA/coB;EAgdpB,SA/ciB;EAgdjB,mCA/ckB;EAgdlB,WFznBU;EE0nBV,kBA/coB;EAgdpB,gBA/csB;EAgdtB,kBA/cqB;EAgdrB,oBAAA;EACA,qBAAA;EACA,eAAA;AD1VJ;AC6VE;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,eAtWsB;EAuWtB,mBAtWwB;EAuWxB,uBAtW4B;EAuW5B,WAtWkB;EAuWlB,qBAtWmB;EAuWnB,UAtWoB;ADWxB;AC8VE;EACE,aAAA;EACA,mBAzUuB;EA0UvB,uBAzU2B;EA0U3B,YAzUiB;EA0UjB,aAzUkB;EA0UlB,iBAzUkB;EA0UlB,8DAzUqB;EA0UrB,oBAzUwB;EA0UxB,mBAzUwB;EA0UxB,mBAzUyB;EA0UzB,qDAzUwB;ADnB5B;AC+VE;EACE,gBArXkB;EAsXlB,sBArXmB;EAsXnB,0CArXsB;EAsXtB,iCArXsB;EAsXtB,gBArXuB;ADwB3B;AC+VI;EACE,eAAA;AD7VN;ACgWI;EAEE,0CAzXwB;EA0XxB,wDAzX+B;EA0X/B,mBAAA;EACA,8DA1XkC;EA2XlC,wCA1XuB;EA2XvB,cA1X2B;AD2BjC;ACiWM;EACE,6FAAA;AD/VR;ACkWM;EACE,6FAAA;ADhWR;ACoWI;EAEE,uCAnYqB;EAoYrB,qDAnY4B;EAoY5B,mBAAA;EACA,2DApY+B;EAqY/B,qCApYoB;EAqYpB,cApYwB;ADiC9B;ACqWM;EACE,0FAAA;ADnWR;ACsWM;EACE,0FAAA;ADpWR;ACwWI;EAEE,yCA7YuB;EA8YvB,uDA7Y8B;EA8Y9B,mBAAA;EACA,6DA9YiC;EA+YjC,uCA9YsB;EA+YtB,cA9Y0B;ADuChC;ACyWM;EACE,4FAAA;ADvWR;AC0WM;EACE,4FAAA;ADxWR;AC4WI;EACE,aAAA;EACA,8CAAA;AD1WN;AC8WM;EACE,YAAA;AD5WR;ACgXI;EACE,SAAA;AD9WN;ACkXE;EACE,eAvfkB;EAwflB,kBAvfmB;EAwfnB,8CAAA;EACA,WFjvBU;EEkvBV,cAvfqB;EAwfrB,kBAvfsB;EAwftB,eAAA;ADhXJ;ACmXE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4BAAA;EACA,gBAAA;EACA,sDAtnBkB;EAunBlB,qDAvnBkB;ADsQtB;ACoXE;EACE,WAAA;EACA,cArgB8B;EAsgB9B,8BArgBkC;ADmJtC;ACqXE;EACE,eAAA;EACA,oBAvmBiB;EAwmBjB,eAAA;ADnXJ;ACsXE;EACE,eFjuB0B;EEkuB1B,sCAvgBuB;EAwgBvB,UAAA;EACA,mBA9gB6B;EA+gB7B,uBA9gBiC;EA+gBjC,YA9gBuB;EA+gBvB,aA9gBwB;EA+gBxB,aA5gBqB;EA6gBrB,eA7gBqB;EA8gBrB,qBAAA;EACA,UA9gByB;EA+gBzB,gBAAA;EACA,gDA/gB4B;EAghB5B,YA/gBwB;EAghBxB,yCArpBkB;EAspBlB,0CA/gByB;EAghBzB,uBA/gB4B;EAghB5B,WFhyBU;EEiyBV,sBA/gB6B;EAghB7B,cFnvB2B;EEovB3B,eAAA;EACA,iBAjiB8B;AD6KlC;ACsXI;EACE,oDAhhB+B;EAihB/B,uBA/gBgC;EAghBhC,cA5oBQ;ADwRd;ACuXI;EACE,aAjhB6B;EAkhB7B,sDAjhBgC;AD4JtC;ACwXI;EACE,SAAA;ADtXN;AC0XE;EACE,UAAA;EACA,uBAxoBmC;EAyoBnC,SAxoB0B;EAyoB1B,4CAxoB2B;EAyoB3B,cAxoB4B;EAyoB5B,WF5zBU;EE6zBV,kBAxoB6B;EAyoB7B,mBAxoB+B;EAyoB/B,mBAxoB+B;EAyoB/B,kBAxoB8B;EAyoB9B,qBAxoB6B;EAyoB7B,sBAxoB8B;EAyoB9B,eAAA;ADxXJ;AC2XE;;;;;;EAME,mBA/oBiB;ADsRrB;AC4XE;;;EAGE,sBAAA;EACA,WArpBgB;EAspBhB,yCA7oBqB;EA8oBrB,yBAppBiB;EAqpBjB,+CAppBwB;EAqpBxB,mCF5yBqB;EE6yBrB,yCArpBqB;EAspBrB,WFz1BU;EE01BV,kBAtpBoB;AD4RxB;AC4XI;;;EACE,gCAAA;EACA,sCAAA;ADxXN;AC2XI;;;EACE,yBAxpBqB;EAypBrB,aAxpBsB;EAypBtB,mFAvpBJ;ADgSF;AC0XI;;;EACE,WAAA;ADtXN;AC0XE;EACE,mBAhrBiB;EAirBjB,uBF31Be;ACmenB;AC0XI;EACE,UAAA;ADxXN;AC2XI;EACE,UAAA;EACA,WFt3BQ;EEu3BR,gBAAA;EACA,kBAAA;ADzXN;AC4XI;;EAEE,eA9rBe;EA+rBf,UAAA;EACA,kBA3rBkB;EA4rBlB,oBAjsBe;ADuUrB;AC8XE;EACE,eAtsBiB;EAusBjB,iBAtsBkB;AD0UtB;AC+XE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,mCFl2BqB;EEm2BrB,kBA1sBoB;AD6UxB;ACgYE;EACE,cAjsBoB;EAksBpB,eAjsBqB;ADmUzB;ACiYE;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,mCF/2BqB;EEg3BrB,WF35BU;EE45BV,kBAxtBoB;ADyVxB;ACkYE;;EAEE,mBAAA;EACA,uBAAA;EACA,uBFh5Be;EEi5Bf,WFp6BU;ACoiBd;ACkYI;;EACE,eAAA;EACA,kBApuBkB;ADqWxB;ACkYI;;EACE,cAAA;EACA,eAAA;AD/XN;ACmYE;EACE,aAAA;EACA,uBA7tBgC;EA8tBhC,kBA/tBuB;AD8V3B;ACoYE;EACE,mBA/tBmC;EAguBnC,uBA/tBuC;EAguBvC,eA/tB8B;EAguB9B,gBA/tB+B;EAguB/B,gBAAA;EACA,uBF35BkC;EE45BlC,WF97BU;EE+7BV,cAhuBiC;EAiuBjC,gBAhuBmC;AD8VvC;ACoYI;EACE,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EAEA,kBAAA;EACA,yBA9yBQ;EA+yBR,WA1uBgC;EA2uBhC,gBAAA;EACA,kBAAA;EACA,kBAAA;ADnYN;ACuYE;EACE,eA9uB6B;EA+uB7B,mBA9uB+B;EA+uB/B,eA9uB6B;EA+uB7B,mBA7uB0B;EA8uB1B,UA7uB2B;EA8uB3B,uBAhvB8B;EAivB9B,gBA9uB+B;ADyWnC;ACuYI;EACE,qBAAA;EACA,kBAAA;ADrYN;ACwYI;EACE,WAAA;EACA,cAAA;EACA,UAtvBsB;EAuvBtB,WAtvBuB;EAuvBvB,kBAtvB8B;EAuvB9B,mBApvByB;EAqvBzB,WApvBoB;EAqvBpB,gBA1vBuB;EA2vBvB,kBAAA;ADtYN;ACwYM;EACE,mBA1vBuB;ADoX/B;ACwYQ;EACE,qCFj9BuB;EEk9BvB,WA/vBkB;ADyX5B;ACyYQ;EACE,qCFt9BuB;AC+kBjC;AC4YI;EACE,WAAA;EACA,cAAA;EACA,YAhxB0B;EAixB1B,aAAA;EACA,cAAA;EACA,mBA7wByB;ADmY/B;;ACiZA;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,wBAx3BkB;EAy3BlB,4BAp3BgB;EAq3BhB,gCAAA;EACA,kBAAA;EACA,kBAx3BwB;EAy3BxB,oBA53BuB;EA63BvB,gBAAA;EACA,eAAA;EACA,iBAAA;AD9YF;ACgZE;EACE,aAAA;EACA,mBAAA;EACA,iBAn4BmB;ADqfvB;ACiZE;EACE,qBAj4BU;EAk4BV,cAl4BU;ADmfd;ACiZI;EACE,kBAAA;EACA,YAAA;AD/YN;ACkZI;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAh5BQ;ADggBd;ACkZM;EACE,cAAA;EACA,wBAAA;ADhZR;ACmZM;EACE,UAAA;EACA,yBAAA;ADjZR;ACsZI;EACE;IACE,wCAAA;EDpZN;ECsZM;IACE,0CAAA;EDpZR;AACF;ACyZE;EACE,qBAz6BY;EA06BZ,cA16BY;ADmhBhB;AC0ZI;EACE;IACE,wCAAA;EDxZN;EC0ZM;IACE,oCAAA;EDxZR;AACF;AC6ZE;EACE,qBAx7BS;EAy7BT,cAz7BS;AD8hBb;AC8ZI;EACE;IACE,wCAAA;ED5ZN;EC8ZM;IACE,oCAAA;ED5ZR;AACF;ACiaE;EACE,qBAv8Ba;EAw8Bb,cAx8Ba;ADyiBjB;ACkaI;EACE;IACE,wCAAA;EDhaN;ECkaM;IACE,2CAAA;EDhaR;AACF;ACqaE;EACE,qBA59BY;EA69BZ,cA79BY;AD0jBhB;ACqaI;EAEE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;ADpaN;ACsaM;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,8BAAA;ADpaR;ACuaM;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;ADraR;ACyaI;EAEE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;ADxaN;AC2aI;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AD1aN;AC6aI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBArhCU;AD0mBhB;AC6aM;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;AD3aR;AC8aM;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AD5aR;ACibI;EAEI;IACE,+CAAA;EDhbR;ECmbM;IACE,gDAAA;EDjbR;ECobM;IACE,2DAAA;EDlbR;AACF;;ACybA;EACE,wCAAA;ADtbF;;ACybA;EACE,4BFptCqB;AC8xBvB;;ACybA;EACE,4BFvtCqB;ACiyBvB;;ACybA;EACE,gBAAA;ADtbF;;AC0bA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ADvbF;;AC4bE;EACE,qBAAA;EACA,cAx+BqB;AD+iBzB;AC4bE;EACE,QAAA;EACA,UAAA;AD1bJ;;AC+bA;EACE,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,mDAAA;EACA,YAp6BoB;EAq6BpB,kBAAA;EACA,iCA96BmB;EA+6BnB,kCFvwCuB;EEwwCvB,yCA/6BuB;EAg7BvB,mBAAA;AD5bF;AC8bE;EACE,cAAA;AD5bJ;AC+bE;EACE,iBA/6BuB;EAg7BvB,UA/6BwB;EAg7BxB,cA/6B0B;EAg7B1B,mBAAA;AD7bJ;ACgcE;EACE,uBAAA;AD9bJ;ACicE;EACE,WAn7BuB;EAo7BvB,aAn7BuB;EAo7BvB,cAn7B0B;ADof9B;ACkcE;EACE,cAt7B+B;ADsfnC;ACmcE;EACE,iBAx7BwB;EAy7BxB,kBAz7BwB;EA07BxB,gBAx7B2B;ADuf/B;ACocE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAn9B6B;EAo9B7B,aAn9B8B;EAo9B9B,SAn9B8B;EAo9B9B,cAn9BiC;ADihBrC;ACqcE;EACE,iBAh9BgC;EAi9BhC,UAh9BiC;EAi9BjC,iBAAA;EACA,cAj9BmC;EAk9BnC,mBAAA;ADncJ;ACqcI;EACE,UAAA;ADncN;ACucE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;ADrcJ;ACwcE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;ADtcJ;ACwcI;EACE,aAAA;EACA,mBAAA;EACA,gBAj/BuB;EAk/BvB,iBAAA;ADtcN;AC0cM;EACE,UAAA;EACA,WAAA;ADxcR;AC6cM;EACE,YAAA;EACA,cAAA;AD3cR;AC6cQ;EACE,cAAA;AD3cV;AC8cQ;EACE,eAAA;AD5cV;ACkdE;EACE,2BAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;ADhdJ;ACmdE;EACE,oBAAA;EACA,oBAAA;EACA,cA/gC4B;AD8jBhC;ACodE;EACE,qBAjuCY;AD+wBhB;ACodI;EAEE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;ADndN;ACqdM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;ADndR;ACsdM;EACE,YAAA;EACA,cAAA;EACA,yBAAA;EACA,0BAAA;ADpdR;ACwdI;EACE,UAAA;EACA,WAAA;ADtdN;ACydI;EACE,MAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;ADvdN;AC0dI;EACE,gBAAA;ADxdN;AC0dM;EACE,YAAA;EACA,cAAA;EACA,aAAA;ADxdR;AC2dM;EACE,aAAA;EACA,eAAA;EACA,cAAA;ADzdR;AC6dI;EAEI;IACE,qDAAA;ED5dR;EC+dM;IACE,sDAAA;ED7dR;AACF;ACkeE;EACE,4CA5mCyB;AD4oB7B;ACmeE;EACE,4CA/mCyB;AD8oB7B;;ACweA;EACE;IACE,qBAAA;EDreF;ECweA;IACE,sBAAA;EDteF;ECyeA;IACE,sBAAA;EDveF;EC0eA;IACE,mBAAA;EDxeF;AACF;AC4eA;EACE;IACE,mBAAA;IACA,UAAA;ED1eF;EC6eA;IACE,qBAAA;IACA,UAAA;ED3eF;AACF;AC+eA;EACE;IACE,aAAA;IACA,cAAA;IACA,QAAA;ED7eF;ECgfA;IACE,aAAA;IACA,aAAA;IACA,QAAA;ED9eF;ECifA;IACE,aAAA;IACA,cAAA;IACA,cAAA;ED/eF;ECkfA;IACE,QAAA;IACA,cAAA;IACA,eAAA;EDhfF;ECmfA;IACE,aAAA;IACA,cAAA;IACA,eAAA;EDjfF;AACF;ACofA;EACE;IACE,YAAA;IACA,cAAA;IACA,QAAA;EDlfF;ECqfA;IACE,YAAA;IACA,cAAA;IACA,QAAA;EDnfF;ECsfA;IACE,aAAA;IACA,QAAA;IACA,eAAA;EDpfF;ECufA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EDrfF;AACF;ACwfA;EACE;IACE,yBAAA;EDtfF;ECyfA;IACE,yBAAA;EDvfF;EC0fA;IACE,0BAAA;EDxfF;EC2fA;IACE,0BAAA;EDzfF;AACF;AC6fA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ED3fF;EC8fA;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ED5fF;EC+fA;IACE,oBAAA;IACA,sBAAA;ED7fF;ECggBA;IACE,aAAA;IACA,mBAAA;IACA,UAAA;ED9fF;AACF;ACigBA;EACE;IACE,0BAAA;IACA,UAAA;ED/fF;ECkgBA;IACE,wBAAA;IACA,UAAA;EDhgBF;AACF;ACmgBA;EACE;IACE,uBAAA;EDjgBF;ECogBA;IACE,yBAAA;EDlgBF;AACF;ACsgBA;EACE;IACE,2BAAA;EDpgBF;ECugBA;IACE,qBAAA;EDrgBF;AACF;ACygBA;EACE;IACE,yBAAA;IACA,UAAA;EDvgBF;EC0gBA;IACE,0BAAA;IACA,YAAA;EDxgBF;EC2gBA;IACE,yBAAA;IACA,YAAA;EDzgBF;EC4gBA;IACE,yBAAA;IACA,UAAA;ED1gBF;EC6gBA;IACE,qBAAA;IACA,UAAA;ED3gBF;AACF;ACghBA;EACE;IACE,6CAAA;ED9gBF;ECihBA;IACE,uCAAA;ED/gBF;ECkhBA;IACE,6CAAA;EDhhBF;ECmhBA;IACE,sCAAA;EDjhBF;AACF;ACohBA;EACE;IACE,wBAAA;IACA,UAAA;EDlhBF;AACF;ACqhBA;EACE;IACE,aAAA;IACA,cAAA;IACA,QAAA;EDnhBF;ECshBA;IACE,YAAA;IACA,aAAA;IACA,QAAA;EDphBF;ECuhBA;IACE,YAAA;IACA,aAAA;IACA,cAAA;EDrhBF;ECwhBA;IACE,aAAA;IACA,YAAA;IACA,YAAA;EDthBF;ECyhBA;IACE,YAAA;IACA,cAAA;IACA,aAAA;EDvhBF;AACF;AC0hBA;EACE;IACE,YAAA;IACA,cAAA;IACA,QAAA;EDxhBF;EC2hBA;IACE,WAAA;IACA,eAAA;IACA,QAAA;EDzhBF;EC4hBA;IACE,aAAA;IACA,QAAA;IACA,cAAA;ED1hBF;EC6hBA;IACE,aAAA;IACA,eAAA;IACA,cAAA;ED3hBF;AACF;AArsCA;EACE,qBAAA;AAusCF;;AApsCA;EACE,wCC+S2B;ADw5B7B","sourcesContent":["$borderless-theme-color: rgba(54, 70, 93, .99);\n$borderless-outline-color: lighten($borderless-theme-color, 30%);\n\n$swal2-white: #fff !default;\n\n// BOX MODEL\n$swal2-box-shadow: none;\n\n// ANIMATIONS\n$swal2-show-animation: opacity-show .3s;\n$swal2-hide-animation: opacity-hide .1s;\n// Appearance animation\n@keyframes opacity-show {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n// Disppearance animation\n@keyframes opacity-hide {\n  100% { opacity: 0; }\n}\n\n// BACKGROUND\n$swal2-background: transparent;\n\n// BACKDROP\n$swal2-backdrop: $borderless-theme-color;\n\n// TITLE\n$swal2-title-color: $swal2-white;\n\n// HTML CONTAINER\n$swal2-html-container-color: $swal2-white;\n\n// PROGRESS STEPS\n$swal2-progress-step-background: lighten($borderless-theme-color, 30%);\n\n// VALIDATION MESSAGE\n$swal2-validation-message-background: transparent;\n$swal2-validation-message-color: $swal2-white;\n\n// FOOTER\n$swal2-footer-color: $swal2-white;\n$swal2-footer-border-color: rgba($swal2-white, .2);\n\n// INPUT\n$swal2-input-color: $swal2-white;\n$swal2-input-background: lighten($borderless-theme-color, 10%);\n\n// CLOSE BUTTON\n$swal2-close-button-position: fixed;\n$swal2-close-button-font-size: 3em;\n$swal2-close-button-color: $swal2-white;\n\n// COMMON VARIABLES FOR CONFIRM AND CANCEL BUTTONS\n$swal2-button-focus-box-shadow: 0 0 0 1px $borderless-theme-color, 0 0 0 3px $borderless-outline-color;\n\n// TOAST\n$swal2-toast-background: $borderless-theme-color;\n$swal2-toast-button-focus-box-shadow: 0 0 0 1px $borderless-theme-color, 0 0 0 3px $borderless-outline-color;\n\n@import 'sweetalert2/src/sweetalert2';\n","@import '@sweetalert2/themes/borderless/borderless.scss';\n\n.swal2-container {\n  font-family: GameFont;\n}\n\na {\n  color: $swal2-confirm-button-color;\n}\n","// SweetAlert2\n// github.com/sweetalert2/sweetalert2\n\n// CSS Variables\n:root {\n  --swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);\n\n  // CONTAINER\n  --swal2-container-padding: 0.625em;\n\n  // BACKDROP\n  --swal2-backdrop: rgba(0, 0, 0, 0.4);\n  --swal2-backdrop-transition: background-color 0.1s;\n\n  // POPUP\n  --swal2-width: 32em;\n  --swal2-padding: 0 0 1.25em;\n  --swal2-border: none;\n  --swal2-border-radius: 0.3125rem;\n  --swal2-background: white;\n  --swal2-color: #545454;\n  --swal2-footer-border-color: #eee;\n\n  // ANIMATIONS\n  --swal2-show-animation: swal2-show 0.3s;\n  --swal2-hide-animation: swal2-hide 0.15s forwards;\n\n  // ICONS\n  --swal2-icon-zoom: 1;\n  --swal2-icon-animations: true;\n\n  // TITLE\n  --swal2-title-padding: 0.8em 1em 0;\n\n  // HTML CONTAINER\n  --swal2-html-container-padding: 1em 1.6em 0.3em;\n\n  // INPUT\n  --swal2-input-border-radius: 0.1875em;\n  --swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;\n  --swal2-input-background: transparent;\n  --swal2-input-transition: border-color 0.2s, box-shadow 0.2s;\n\n  // PROGRESS STEPS\n  --swal2-progress-step-background: #add8e6;\n\n  // VALIDATION MESSAGE\n  --swal2-validation-message-background: #f0f0f0;\n  --swal2-validation-message-color: #666;\n\n  // CLOSE BUTTON\n  --swal2-close-button-position: initial;\n  --swal2-close-button-inset: auto;\n  --swal2-close-button-font-size: 2.5em;\n  --swal2-close-button-color: #ccc;\n  --swal2-close-button-transition: color 0.2s, box-shadow 0.2s;\n  --swal2-close-button-outline: initial;\n  --swal2-close-button-box-shadow: inset 0 0 0 3px transparent;\n  --swal2-close-button-focus-box-shadow: inset var(--swal2-outline);\n\n  // CLOSE BUTTON:HOVER\n  --swal2-close-button-hover-transform: none;\n\n  // COMMON VARIABLES FOR ALL ACTION BUTTONS\n  --swal2-button-transition: background-color 0.2s, box-shadow 0.2s;\n\n  // CONFIRM BUTTON\n  --swal2-confirm-button-border: 0;\n  --swal2-confirm-button-border-radius: 0.25em;\n  --swal2-confirm-button-background-color: #7066e0;\n  --swal2-confirm-button-color: #fff;\n\n  // DENY BUTTON\n  --swal2-deny-button-border: 0;\n  --swal2-deny-button-border-radius: 0.25em;\n  --swal2-deny-button-background-color: #dc3741;\n  --swal2-deny-button-color: #fff;\n\n  // CANCEL BUTTON\n  --swal2-cancel-button-border: 0;\n  --swal2-cancel-button-border-radius: 0.25em;\n  --swal2-cancel-button-background-color: #6e7881;\n  --swal2-cancel-button-color: #fff;\n\n  // TOASTS\n  --swal2-toast-show-animation: swal2-toast-show 0.5s;\n  --swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;\n  --swal2-toast-border: none;\n  --swal2-toast-box-shadow:\n    0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075),\n    1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075);\n}\n\n// DARK THEME\n@mixin dark-theme {\n  --swal2-dark-theme-black: #19191a;\n  --swal2-dark-theme-white: #e1e1e1;\n\n  // POPUP\n  --swal2-background: var(--swal2-dark-theme-black);\n  --swal2-color: var(--swal2-dark-theme-white);\n  --swal2-footer-border-color: #555;\n\n  // INPUT\n  --swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);\n\n  // VALIDATION MESSAGE\n  --swal2-validation-message-background: color-mix(\n    in srgb,\n    var(--swal2-dark-theme-black),\n    var(--swal2-dark-theme-white) 10%\n  );\n  --swal2-validation-message-color: var(--swal2-dark-theme-white);\n}\n\n[data-swal2-theme='dark'] {\n  @include dark-theme;\n}\n\n// AUTO THEME, based on prefers-color-scheme\n@media (prefers-color-scheme: dark) {\n  [data-swal2-theme='auto'] {\n    @include dark-theme;\n  }\n}\n\n$swal2-outline-color: rgba(100, 150, 200, 0.5) !default;\n\n// CONTAINER\n$swal2-container-padding: var(--swal2-container-padding) !default;\n\n// BACKDROP\n$swal2-backdrop: var(--swal2-backdrop) !default;\n$swal2-backdrop-transition: var(--swal2-backdrop-transition) !default;\n\n// POPUP\n$swal2-width: var(--swal2-width) !default;\n$swal2-padding: var(--swal2-padding) !default;\n$swal2-border: var(--swal2-border) !default;\n$swal2-border-radius: var(--swal2-border-radius) !default;\n$swal2-background: var(--swal2-background) !default;\n$swal2-color: var(--swal2-color) !default;\n\n// ANIMATIONS\n$swal2-show-animation: var(--swal2-show-animation) !default;\n$swal2-hide-animation: var(--swal2-hide-animation) !default;\n\n// TYPOGRAPHY\n$swal2-font: inherit !default;\n$swal2-font-size: 1rem !default;\n\n// ICONS\n$swal2-icon-margin: 2.5em auto 0.6em !default;\n$swal2-icon-font-family: inherit !default;\n$swal2-icon-font-size: 3.75em !default;\n$swal2-icon-border-width: 0.25em !default;\n$swal2-icon-border-color: #000 !default;\n$swal2-icon-zoom: var(--swal2-icon-zoom) !default;\n$swal2-success: #a5dc86 !default;\n$swal2-success-border: rgba($swal2-success, 0.3) !default;\n$swal2-error: #f27474 !default;\n$swal2-warning: #f8bb86 !default;\n$swal2-info: #3fc3ee !default;\n$swal2-question: #87adbd !default;\n\n// IMAGE\n$swal2-image-margin: 2em auto 1em !default;\n\n// TITLE\n$swal2-title-position: relative !default;\n$swal2-title-max-width: 100% !default;\n$swal2-title-margin: 0 !default;\n$swal2-title-padding: var(--swal2-title-padding) !default;\n$swal2-title-color: inherit !default;\n$swal2-title-font-size: 1.875em !default;\n$swal2-title-font-weight: 600 !default;\n$swal2-title-text-align: center !default;\n\n// HTML CONTAINER\n$swal2-html-container-justify-content: center !default;\n$swal2-html-container-margin: 0 !default;\n$swal2-html-container-padding: var(--swal2-html-container-padding) !default;\n$swal2-html-container-overflow: auto !default;\n$swal2-html-container-color: inherit !default;\n$swal2-html-container-font-size: 1.125em !default;\n$swal2-html-container-font-weight: normal !default;\n$swal2-html-container-line-height: normal !default;\n$swal2-html-container-text-align: center !default;\n$swal2-html-container-word-wrap: break-word !default;\n$swal2-html-container-word-break: break-word !default;\n\n// INPUT\n$swal2-input-margin: 1em 2em 3px !default;\n$swal2-input-width: auto !default;\n$swal2-input-height: 2.625em !default;\n$swal2-input-padding: 0 0.75em !default;\n$swal2-input-border: 1px solid #d9d9d9 !default;\n$swal2-input-border-radius: var(--swal2-input-border-radius) !default;\n$swal2-input-box-shadow: var(--swal2-input-box-shadow) !default;\n$swal2-input-font-size: 1.125em !default;\n$swal2-input-background: var(--swal2-input-background) !default;\n$swal2-input-color: inherit !default;\n$swal2-input-transition: var(--swal2-input-transition) !default;\n\n// INPUT:FOCUS\n$swal2-input-focus-border: 1px solid #b4dbed !default;\n$swal2-input-focus-outline: none !default;\n$swal2-input-focus-box-shadow:\n  inset 0 1px 1px rgba(0, 0, 0, 0.06),\n  0 0 0 3px $swal2-outline-color !default;\n\n// TEXTAREA SPECIFIC VARIABLES\n$swal2-textarea-height: 6.75em !default;\n$swal2-textarea-padding: 0.75em !default;\n\n// INPUT LABEL\n$swal2-input-label-margin: 1em auto 0 !default;\n$swal2-input-label-justify-content: center !default;\n\n// VALIDATION MESSAGE\n$swal2-validation-message-align-items: center !default;\n$swal2-validation-message-justify-content: center !default;\n$swal2-validation-message-margin: 1em 0 0 !default;\n$swal2-validation-message-padding: 0.625em !default;\n$swal2-validation-message-background: var(--swal2-validation-message-background) !default;\n$swal2-validation-message-color: var(--swal2-validation-message-color) !default;\n$swal2-validation-message-font-size: 1em !default;\n$swal2-validation-message-font-weight: 300 !default;\n$swal2-validation-message-icon-background: $swal2-error !default;\n$swal2-validation-message-icon-color: #fff !default;\n$swal2-validation-message-icon-zoom: null !default;\n\n// PROGRESS STEPS\n$swal2-progress-steps-flex-wrap: wrap !default;\n$swal2-progress-steps-align-items: center !default;\n$swal2-progress-steps-max-width: 100% !default;\n$swal2-progress-steps-background: transparent !default;\n$swal2-progress-steps-margin: 1.25em auto !default;\n$swal2-progress-steps-padding: 0 !default;\n$swal2-progress-steps-font-weight: 600 !default;\n$swal2-progress-steps-distance: 2.5em !default;\n$swal2-progress-step-width: 2em;\n$swal2-progress-step-height: 2em;\n$swal2-progress-step-border-radius: 2em;\n$swal2-progress-step-background: var(--swal2-progress-step-background) !default;\n$swal2-progress-step-color: #fff !default;\n$swal2-active-step-background: #2778c4 !default;\n$swal2-active-step-color: #fff !default;\n\n// FOOTER\n$swal2-footer-margin: 1em 0 0 !default;\n$swal2-footer-padding: 1em 1em 0 !default;\n$swal2-footer-border-color: var(--swal2-footer-border-color) !default;\n$swal2-footer-color: inherit !default;\n$swal2-footer-font-size: 1em !default;\n$swal2-footer-text-align: center !default;\n\n// TIMER PROGRESS BAR\n$swal2-timer-progress-bar-height: 0.25em;\n$swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.2) !default;\n\n// CLOSE BUTTON\n$swal2-close-button-justify-self: end !default;\n$swal2-close-button-align-items: center !default;\n$swal2-close-button-justify-content: center !default;\n$swal2-close-button-width: 1.2em !default;\n$swal2-close-button-height: 1.2em !default;\n$swal2-close-button-position: var(--swal2-close-button-position) !default;\n$swal2-close-button-inset: var(--swal2-close-button-inset) !default;\n$swal2-close-button-gap: 0 !default;\n$swal2-close-button-padding: 0 !default;\n$swal2-close-button-transition: var(--swal2-close-button-transition) !default;\n$swal2-close-button-border: none !default;\n$swal2-close-button-border-radius: $swal2-border-radius !default;\n$swal2-close-button-outline: var(--swal2-close-button-outline) !default;\n$swal2-close-button-background: transparent !default;\n$swal2-close-button-color: var(--swal2-close-button-color) !default;\n$swal2-close-button-font-family: monospace !default;\n$swal2-close-button-font-size: var(--swal2-close-button-font-size) !default;\n$swal2-close-button-box-shadow: var(--swal2-close-button-box-shadow) !default;\n\n// CLOSE BUTTON:HOVER\n$swal2-close-button-hover-transform: var(--swal2-close-button-hover-transform) !default;\n$swal2-close-button-hover-color: $swal2-error !default;\n$swal2-close-button-hover-background: transparent !default;\n\n// CLOSE BUTTON:FOCUS\n$swal2-close-button-focus-outline: none !default;\n$swal2-close-button-focus-box-shadow: var(--swal2-close-button-focus-box-shadow) !default;\n\n// ACTIONS\n$swal2-actions-flex-wrap: wrap !default;\n$swal2-actions-align-items: center !default;\n$swal2-actions-justify-content: center !default;\n$swal2-actions-width: auto !default;\n$swal2-actions-margin: 1.25em auto 0 !default;\n$swal2-actions-padding: 0 !default;\n\n// COMMON VARIABLES FOR ALL ACTION BUTTONS\n$swal2-button-margin: 0.3125em !default;\n$swal2-button-padding: 0.625em 1.1em !default;\n$swal2-button-transition: var(--swal2-button-transition) !default;\n$swal2-button-box-shadow: 0 0 0 3px transparent !default;\n$swal2-button-font-weight: 500 !default;\n\n// CONFIRM BUTTON\n$swal2-confirm-button-order: null !default;\n$swal2-confirm-button-border: var(--swal2-confirm-button-border) !default;\n$swal2-confirm-button-border-radius: var(--swal2-confirm-button-border-radius) !default;\n$swal2-confirm-button-background-color: var(--swal2-confirm-button-background-color) !default;\n$swal2-confirm-button-color: var(--swal2-confirm-button-color) !default;\n$swal2-confirm-button-font-size: 1em !default;\n\n// DENY BUTTON\n$swal2-deny-button-order: null !default;\n$swal2-deny-button-border: var(--swal2-deny-button-border) !default;\n$swal2-deny-button-border-radius: var(--swal2-deny-button-border-radius) !default;\n$swal2-deny-button-background-color: var(--swal2-deny-button-background-color) !default;\n$swal2-deny-button-color: var(--swal2-deny-button-color) !default;\n$swal2-deny-button-font-size: 1em !default;\n\n// CANCEL BUTTON\n$swal2-cancel-button-order: null !default;\n$swal2-cancel-button-border: var(--swal2-cancel-button-border) !default;\n$swal2-cancel-button-border-radius: var(--swal2-cancel-button-border-radius) !default;\n$swal2-cancel-button-background-color: var(--swal2-cancel-button-background-color) !default;\n$swal2-cancel-button-color: var(--swal2-cancel-button-color) !default;\n$swal2-cancel-button-font-size: 1em !default;\n\n// LOADER\n$swal2-loader-align-items: center !default;\n$swal2-loader-justify-content: center !default;\n$swal2-loader-width: 2.2em !default;\n$swal2-loader-height: 2.2em !default;\n$swal2-loader-margin: 0 1.875em !default;\n$swal2-loader-animation: swal2-rotate-loading 1.5s linear 0s infinite normal !default;\n$swal2-loader-border-width: 0.25em !default;\n$swal2-loader-border-style: solid !default;\n$swal2-loader-border-radius: 100% !default;\n$swal2-loader-border-color: #2778c4 transparent #2778c4 transparent !default;\n\n// TOASTS\n$swal2-toast-show-animation: var(--swal2-toast-show-animation) !default;\n$swal2-toast-hide-animation: var(--swal2-toast-hide-animation) !default;\n$swal2-toast-border: var(--swal2-toast-border) !default;\n$swal2-toast-box-shadow: var(--swal2-toast-box-shadow) !default;\n$swal2-toast-background: $swal2-background !default;\n$swal2-toast-close-button-width: 0.8em !default;\n$swal2-toast-close-button-height: 0.8em !default;\n$swal2-toast-close-button-margin: 0 !default;\n$swal2-toast-close-button-font-size: 2em !default;\n$swal2-toast-width: 360px !default;\n$swal2-toast-padding: 1em !default;\n$swal2-toast-title-margin: 0.5em 1em !default;\n$swal2-toast-title-padding: 0 !default;\n$swal2-toast-title-font-size: 1em !default;\n$swal2-toast-icon-font-size: 1.8em !default;\n$swal2-toast-html-container-margin: 0.5em 1em !default;\n$swal2-toast-html-container-padding: 0 !default;\n$swal2-toast-html-container-font-size: 1em !default;\n$swal2-toast-input-height: 2em !default;\n$swal2-toast-input-margin: 0.5em !default;\n$swal2-toast-input-font-size: 1em !default;\n$swal2-toast-validation-font-size: 1em !default;\n$swal2-toast-buttons-font-size: 1em !default;\n$swal2-toast-footer-margin: 0.5em 0 0 !default;\n$swal2-toast-footer-padding: 0.5em 0 0 !default;\n$swal2-toast-footer-font-size: 0.8em !default;\n\nbody {\n  // MODAL\n  &.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) {\n    overflow: hidden; // not overflow-y because of Sarari, #1253\n  }\n\n  &.swal2-height-auto {\n    height: auto !important; // #781 #1107\n  }\n\n  &.swal2-no-backdrop {\n    .swal2-container {\n      background-color: transparent !important;\n      pointer-events: none;\n\n      .swal2-popup {\n        pointer-events: all;\n      }\n\n      .swal2-modal {\n        box-shadow: 0 0 10px $swal2-backdrop;\n      }\n    }\n  }\n\n  // TOAST\n  &.swal2-toast-shown {\n    .swal2-container {\n      box-sizing: border-box;\n      width: $swal2-toast-width;\n      max-width: 100%;\n      background-color: transparent;\n      pointer-events: none;\n\n      &.swal2-top {\n        inset: 0 auto auto 50%;\n        transform: translateX(-50%);\n      }\n\n      &.swal2-top-end,\n      &.swal2-top-right {\n        inset: 0 0 auto auto;\n      }\n\n      &.swal2-top-start,\n      &.swal2-top-left {\n        inset: 0 auto auto 0;\n      }\n\n      &.swal2-center-start,\n      &.swal2-center-left {\n        inset: 50% auto auto 0;\n        transform: translateY(-50%);\n      }\n\n      &.swal2-center {\n        inset: 50% auto auto 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      &.swal2-center-end,\n      &.swal2-center-right {\n        inset: 50% 0 auto auto;\n        transform: translateY(-50%);\n      }\n\n      &.swal2-bottom-start,\n      &.swal2-bottom-left {\n        inset: auto auto 0 0;\n      }\n\n      &.swal2-bottom {\n        inset: auto auto 0 50%;\n        transform: translateX(-50%);\n      }\n\n      &.swal2-bottom-end,\n      &.swal2-bottom-right {\n        inset: auto 0 0 auto;\n      }\n    }\n  }\n\n  // PRINT\n  @media print {\n    &.swal2-shown:not(.swal2-no-backdrop, .swal2-toast-shown) {\n      overflow-y: scroll !important;\n\n      > [aria-hidden='true'] {\n        display: none;\n      }\n\n      .swal2-container {\n        position: static !important;\n      }\n    }\n  }\n}\n\n// MODAL\ndiv:where(.swal2-container) {\n  display: grid;\n  position: fixed;\n  z-index: 1060;\n  inset: 0;\n  box-sizing: border-box;\n  grid-template-areas:\n    'top-start     top            top-end'\n    'center-start  center         center-end'\n    'bottom-start  bottom-center  bottom-end';\n  grid-template-rows: minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);\n  height: 100%; // Safari\n  padding: $swal2-container-padding;\n  overflow-x: hidden;\n  transition: $swal2-backdrop-transition;\n\n  // sweetalert2/issues/905\n  -webkit-overflow-scrolling: touch;\n\n  &.swal2-backdrop-show,\n  &.swal2-noanimation {\n    background: $swal2-backdrop;\n  }\n\n  &.swal2-backdrop-hide {\n    background: transparent !important;\n  }\n\n  &.swal2-top-start,\n  &.swal2-center-start,\n  &.swal2-bottom-start {\n    grid-template-columns: minmax(0, 1fr) auto auto;\n  }\n\n  &.swal2-top,\n  &.swal2-center,\n  &.swal2-bottom {\n    grid-template-columns: auto minmax(0, 1fr) auto;\n  }\n\n  &.swal2-top-end,\n  &.swal2-center-end,\n  &.swal2-bottom-end {\n    grid-template-columns: auto auto minmax(0, 1fr);\n  }\n\n  &.swal2-top-start > .swal2-popup {\n    align-self: start;\n  }\n\n  &.swal2-top > .swal2-popup {\n    grid-column: 2;\n    place-self: start center;\n  }\n\n  &.swal2-top-end > .swal2-popup,\n  &.swal2-top-right > .swal2-popup {\n    grid-column: 3;\n    place-self: start end;\n  }\n\n  &.swal2-center-start > .swal2-popup,\n  &.swal2-center-left > .swal2-popup {\n    grid-row: 2;\n    align-self: center;\n  }\n\n  &.swal2-center > .swal2-popup {\n    grid-column: 2;\n    grid-row: 2;\n    place-self: center center;\n  }\n\n  &.swal2-center-end > .swal2-popup,\n  &.swal2-center-right > .swal2-popup {\n    grid-column: 3;\n    grid-row: 2;\n    place-self: center end;\n  }\n\n  &.swal2-bottom-start > .swal2-popup,\n  &.swal2-bottom-left > .swal2-popup {\n    grid-column: 1;\n    grid-row: 3;\n    align-self: end;\n  }\n\n  &.swal2-bottom > .swal2-popup {\n    grid-column: 2;\n    grid-row: 3;\n    place-self: end center;\n  }\n\n  &.swal2-bottom-end > .swal2-popup,\n  &.swal2-bottom-right > .swal2-popup {\n    grid-column: 3;\n    grid-row: 3;\n    place-self: end end;\n  }\n\n  &.swal2-grow-row > .swal2-popup,\n  &.swal2-grow-fullscreen > .swal2-popup {\n    grid-column: 1/4;\n    width: 100%;\n  }\n\n  &.swal2-grow-column > .swal2-popup,\n  &.swal2-grow-fullscreen > .swal2-popup {\n    grid-row: 1/4;\n    align-self: stretch;\n  }\n\n  &.swal2-no-transition {\n    transition: none !important;\n  }\n\n  &[popover] {\n    width: auto;\n    border: 0;\n  }\n\n  div:where(.swal2-popup) {\n    display: none;\n    position: relative;\n    box-sizing: border-box;\n    grid-template-columns: minmax(0, 100%);\n    width: $swal2-width;\n    max-width: 100%;\n    padding: $swal2-padding;\n    border: $swal2-border;\n    border-radius: $swal2-border-radius;\n    background: $swal2-background;\n    color: $swal2-color;\n    font-family: $swal2-font;\n    font-size: $swal2-font-size;\n    container-name: swal2-popup;\n\n    &:focus {\n      outline: none;\n    }\n\n    &.swal2-loading {\n      overflow-y: hidden;\n    }\n\n    &.swal2-draggable {\n      cursor: grab;\n\n      div:where(.swal2-icon) {\n        cursor: grab;\n      }\n    }\n\n    &.swal2-dragging {\n      cursor: grabbing;\n\n      div:where(.swal2-icon) {\n        cursor: grabbing;\n      }\n    }\n  }\n\n  h2:where(.swal2-title) {\n    position: $swal2-title-position;\n    max-width: $swal2-title-max-width;\n    margin: $swal2-title-margin;\n    padding: $swal2-title-padding;\n    color: $swal2-title-color;\n    font-size: $swal2-title-font-size;\n    font-weight: $swal2-title-font-weight;\n    text-align: $swal2-title-text-align;\n    text-transform: none;\n    word-wrap: break-word;\n    cursor: initial;\n  }\n\n  div:where(.swal2-actions) {\n    display: flex;\n    z-index: 1; // prevent success icon from overlapping buttons\n    box-sizing: border-box;\n    flex-wrap: $swal2-actions-flex-wrap;\n    align-items: $swal2-actions-align-items;\n    justify-content: $swal2-actions-justify-content;\n    width: $swal2-actions-width;\n    margin: $swal2-actions-margin;\n    padding: $swal2-actions-padding;\n  }\n\n  div:where(.swal2-loader) {\n    display: none;\n    align-items: $swal2-loader-align-items;\n    justify-content: $swal2-loader-justify-content;\n    width: $swal2-loader-width;\n    height: $swal2-loader-height;\n    margin: $swal2-loader-margin;\n    animation: $swal2-loader-animation;\n    border-width: $swal2-loader-border-width;\n    border-style: $swal2-loader-border-style;\n    border-radius: $swal2-loader-border-radius;\n    border-color: $swal2-loader-border-color;\n  }\n\n  button:where(.swal2-styled) {\n    margin: $swal2-button-margin;\n    padding: $swal2-button-padding;\n    transition: $swal2-button-transition;\n    box-shadow: $swal2-button-box-shadow;\n    font-weight: $swal2-button-font-weight;\n\n    &:not([disabled]) {\n      cursor: pointer;\n    }\n\n    &:where(.swal2-confirm) {\n      order: $swal2-confirm-button-order;\n      border: $swal2-confirm-button-border;\n      border-radius: $swal2-confirm-button-border-radius;\n      background: initial;\n      background-color: $swal2-confirm-button-background-color;\n      color: $swal2-confirm-button-color;\n      font-size: $swal2-confirm-button-font-size;\n\n      &:hover {\n        background-color: color-mix(in srgb, $swal2-confirm-button-background-color, black 10%);\n      }\n\n      &:active {\n        background-color: color-mix(in srgb, $swal2-confirm-button-background-color, black 20%);\n      }\n    }\n\n    &:where(.swal2-deny) {\n      order: $swal2-deny-button-order;\n      border: $swal2-deny-button-border;\n      border-radius: $swal2-deny-button-border-radius;\n      background: initial;\n      background-color: $swal2-deny-button-background-color;\n      color: $swal2-deny-button-color;\n      font-size: $swal2-deny-button-font-size;\n\n      &:hover {\n        background-color: color-mix(in srgb, $swal2-deny-button-background-color, black 10%);\n      }\n\n      &:active {\n        background-color: color-mix(in srgb, $swal2-deny-button-background-color, black 20%);\n      }\n    }\n\n    &:where(.swal2-cancel) {\n      order: $swal2-cancel-button-order;\n      border: $swal2-cancel-button-border;\n      border-radius: $swal2-cancel-button-border-radius;\n      background: initial;\n      background-color: $swal2-cancel-button-background-color;\n      color: $swal2-cancel-button-color;\n      font-size: $swal2-cancel-button-font-size;\n\n      &:hover {\n        background-color: color-mix(in srgb, $swal2-cancel-button-background-color, black 10%);\n      }\n\n      &:active {\n        background-color: color-mix(in srgb, $swal2-cancel-button-background-color, black 20%);\n      }\n    }\n\n    &:focus-visible {\n      outline: none;\n      box-shadow: var(--swal2-action-button-outline);\n    }\n\n    &[disabled] {\n      &:not(.swal2-loading) {\n        opacity: 0.4;\n      }\n    }\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  div:where(.swal2-footer) {\n    margin: $swal2-footer-margin;\n    padding: $swal2-footer-padding;\n    border-top: 1px solid $swal2-footer-border-color;\n    color: $swal2-footer-color;\n    font-size: $swal2-footer-font-size;\n    text-align: $swal2-footer-text-align;\n    cursor: initial;\n  }\n\n  .swal2-timer-progress-bar-container {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    grid-column: auto !important;\n    overflow: hidden;\n    border-bottom-right-radius: $swal2-border-radius;\n    border-bottom-left-radius: $swal2-border-radius;\n  }\n\n  div:where(.swal2-timer-progress-bar) {\n    width: 100%;\n    height: $swal2-timer-progress-bar-height;\n    background: $swal2-timer-progress-bar-background;\n  }\n\n  img:where(.swal2-image) {\n    max-width: 100%;\n    margin: $swal2-image-margin;\n    cursor: initial;\n  }\n\n  button:where(.swal2-close) {\n    position: $swal2-close-button-position;\n    inset: $swal2-close-button-inset;\n    z-index: 2; // sweetalert2/issues/1617\n    align-items: $swal2-close-button-align-items;\n    justify-content: $swal2-close-button-justify-content;\n    width: $swal2-close-button-width;\n    height: $swal2-close-button-height;\n    margin-top: $swal2-close-button-gap;\n    margin-right: $swal2-close-button-gap;\n    margin-bottom: -$swal2-close-button-height;\n    padding: $swal2-close-button-padding;\n    overflow: hidden;\n    transition: $swal2-close-button-transition;\n    border: $swal2-close-button-border;\n    border-radius: $swal2-close-button-border-radius;\n    outline: $swal2-close-button-outline;\n    background: $swal2-close-button-background;\n    color: $swal2-close-button-color;\n    font-family: $swal2-close-button-font-family;\n    font-size: $swal2-close-button-font-size;\n    cursor: pointer;\n    justify-self: $swal2-close-button-justify-self;\n\n    &:hover {\n      transform: $swal2-close-button-hover-transform;\n      background: $swal2-close-button-hover-background;\n      color: $swal2-close-button-hover-color;\n    }\n\n    &:focus-visible {\n      outline: $swal2-close-button-focus-outline;\n      box-shadow: $swal2-close-button-focus-box-shadow;\n    }\n\n    &::-moz-focus-inner {\n      border: 0;\n    }\n  }\n\n  div:where(.swal2-html-container) {\n    z-index: 1; // prevent success icon overlapping the content\n    justify-content: $swal2-html-container-justify-content;\n    margin: $swal2-html-container-margin;\n    padding: $swal2-html-container-padding;\n    overflow: $swal2-html-container-overflow;\n    color: $swal2-html-container-color;\n    font-size: $swal2-html-container-font-size;\n    font-weight: $swal2-html-container-font-weight;\n    line-height: $swal2-html-container-line-height;\n    text-align: $swal2-html-container-text-align;\n    word-wrap: $swal2-html-container-word-wrap;\n    word-break: $swal2-html-container-word-break;\n    cursor: initial;\n  }\n\n  input:where(.swal2-input),\n  input:where(.swal2-file),\n  textarea:where(.swal2-textarea),\n  select:where(.swal2-select),\n  div:where(.swal2-radio),\n  label:where(.swal2-checkbox) {\n    margin: $swal2-input-margin;\n  }\n\n  input:where(.swal2-input),\n  input:where(.swal2-file),\n  textarea:where(.swal2-textarea) {\n    box-sizing: border-box;\n    width: $swal2-input-width;\n    transition: $swal2-input-transition;\n    border: $swal2-input-border;\n    border-radius: $swal2-input-border-radius;\n    background: $swal2-input-background;\n    box-shadow: $swal2-input-box-shadow;\n    color: $swal2-input-color;\n    font-size: $swal2-input-font-size;\n\n    &.swal2-inputerror {\n      border-color: $swal2-error !important;\n      box-shadow: 0 0 2px $swal2-error !important;\n    }\n\n    &:focus {\n      border: $swal2-input-focus-border;\n      outline: $swal2-input-focus-outline;\n      box-shadow: $swal2-input-focus-box-shadow;\n    }\n\n    &::placeholder {\n      color: #ccc;\n    }\n  }\n\n  .swal2-range {\n    margin: $swal2-input-margin;\n    background: $swal2-background;\n\n    input {\n      width: 80%;\n    }\n\n    output {\n      width: 20%;\n      color: $swal2-input-color;\n      font-weight: 600;\n      text-align: center;\n    }\n\n    input,\n    output {\n      height: $swal2-input-height;\n      padding: 0;\n      font-size: $swal2-input-font-size;\n      line-height: $swal2-input-height;\n    }\n  }\n\n  .swal2-input {\n    height: $swal2-input-height;\n    padding: $swal2-input-padding;\n  }\n\n  .swal2-file {\n    width: 75%;\n    margin-right: auto;\n    margin-left: auto;\n    background: $swal2-input-background;\n    font-size: $swal2-input-font-size;\n  }\n\n  .swal2-textarea {\n    height: $swal2-textarea-height;\n    padding: $swal2-textarea-padding;\n  }\n\n  .swal2-select {\n    min-width: 50%;\n    max-width: 100%;\n    padding: 0.375em 0.625em;\n    background: $swal2-input-background;\n    color: $swal2-input-color;\n    font-size: $swal2-input-font-size;\n  }\n\n  .swal2-radio,\n  .swal2-checkbox {\n    align-items: center;\n    justify-content: center;\n    background: $swal2-background;\n    color: $swal2-input-color;\n\n    label {\n      margin: 0 0.6em;\n      font-size: $swal2-input-font-size;\n    }\n\n    input {\n      flex-shrink: 0;\n      margin: 0 0.4em;\n    }\n  }\n\n  label:where(.swal2-input-label) {\n    display: flex;\n    justify-content: $swal2-input-label-justify-content;\n    margin: $swal2-input-label-margin;\n  }\n\n  div:where(.swal2-validation-message) {\n    align-items: $swal2-validation-message-align-items;\n    justify-content: $swal2-validation-message-justify-content;\n    margin: $swal2-validation-message-margin;\n    padding: $swal2-validation-message-padding;\n    overflow: hidden;\n    background: $swal2-validation-message-background;\n    color: $swal2-validation-message-color;\n    font-size: $swal2-validation-message-font-size;\n    font-weight: $swal2-validation-message-font-weight;\n\n    &::before {\n      content: '!';\n      display: inline-block;\n      width: 1.5em;\n      min-width: 1.5em;\n      height: 1.5em;\n      margin: 0 0.625em;\n      zoom: $swal2-validation-message-icon-zoom;\n      border-radius: 50%;\n      background-color: $swal2-validation-message-icon-background;\n      color: $swal2-validation-message-icon-color;\n      font-weight: 600;\n      line-height: 1.5em;\n      text-align: center;\n    }\n  }\n\n  .swal2-progress-steps {\n    flex-wrap: $swal2-progress-steps-flex-wrap;\n    align-items: $swal2-progress-steps-align-items;\n    max-width: $swal2-progress-steps-max-width;\n    margin: $swal2-progress-steps-margin;\n    padding: $swal2-progress-steps-padding;\n    background: $swal2-progress-steps-background;\n    font-weight: $swal2-progress-steps-font-weight;\n\n    li {\n      display: inline-block;\n      position: relative;\n    }\n\n    .swal2-progress-step {\n      z-index: 20;\n      flex-shrink: 0;\n      width: $swal2-progress-step-width;\n      height: $swal2-progress-step-height;\n      border-radius: $swal2-progress-step-border-radius;\n      background: $swal2-active-step-background;\n      color: $swal2-active-step-color;\n      line-height: $swal2-progress-step-height;\n      text-align: center;\n\n      &.swal2-active-progress-step {\n        background: $swal2-active-step-background;\n\n        ~ .swal2-progress-step {\n          background: $swal2-progress-step-background;\n          color: $swal2-progress-step-color;\n        }\n\n        ~ .swal2-progress-step-line {\n          background: $swal2-progress-step-background;\n        }\n      }\n    }\n\n    .swal2-progress-step-line {\n      z-index: 10;\n      flex-shrink: 0;\n      width: $swal2-progress-steps-distance;\n      height: 0.4em;\n      margin: 0 -1px;\n      background: $swal2-active-step-background;\n    }\n  }\n}\n\n// ICONS\n\ndiv:where(.swal2-icon) {\n  position: relative;\n  box-sizing: content-box;\n  justify-content: center;\n  width: 5em;\n  height: 5em;\n  margin: $swal2-icon-margin;\n  zoom: $swal2-icon-zoom;\n  border: $swal2-icon-border-width solid transparent;\n  border-radius: 50%;\n  border-color: $swal2-icon-border-color;\n  font-family: $swal2-icon-font-family;\n  line-height: 5em;\n  cursor: default;\n  user-select: none;\n\n  .swal2-icon-content {\n    display: flex;\n    align-items: center;\n    font-size: $swal2-icon-font-size;\n  }\n\n  &.swal2-error {\n    border-color: $swal2-error;\n    color: $swal2-error;\n\n    .swal2-x-mark {\n      position: relative;\n      flex-grow: 1;\n    }\n\n    [class^='swal2-x-mark-line'] {\n      display: block;\n      position: absolute;\n      top: 2.3125em;\n      width: 2.9375em;\n      height: 0.3125em;\n      border-radius: 0.125em;\n      background-color: $swal2-error;\n\n      &[class$='left'] {\n        left: 1.0625em;\n        transform: rotate(45deg);\n      }\n\n      &[class$='right'] {\n        right: 1em;\n        transform: rotate(-45deg);\n      }\n    }\n\n    // Error icon animation\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        animation: swal2-animate-error-icon 0.5s;\n\n        .swal2-x-mark {\n          animation: swal2-animate-error-x-mark 0.5s;\n        }\n      }\n    }\n  }\n\n  &.swal2-warning {\n    border-color: $swal2-warning;\n    color: $swal2-warning;\n\n    // Warning icon animation\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        animation: swal2-animate-error-icon 0.5s;\n\n        .swal2-icon-content {\n          animation: swal2-animate-i-mark 0.5s;\n        }\n      }\n    }\n  }\n\n  &.swal2-info {\n    border-color: $swal2-info;\n    color: $swal2-info;\n\n    // Info icon animation\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        animation: swal2-animate-error-icon 0.5s;\n\n        .swal2-icon-content {\n          animation: swal2-animate-i-mark 0.8s;\n        }\n      }\n    }\n  }\n\n  &.swal2-question {\n    border-color: $swal2-question;\n    color: $swal2-question;\n\n    // Question icon animation\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        animation: swal2-animate-error-icon 0.5s;\n\n        .swal2-icon-content {\n          animation: swal2-animate-question-mark 0.8s;\n        }\n      }\n    }\n  }\n\n  &.swal2-success {\n    border-color: $swal2-success;\n    color: $swal2-success;\n\n    [class^='swal2-success-circular-line'] {\n      // Emulate moving circular line\n      position: absolute;\n      width: 3.75em;\n      height: 7.5em;\n      border-radius: 50%;\n\n      &[class$='left'] {\n        top: -0.4375em;\n        left: -2.0635em;\n        transform: rotate(-45deg);\n        transform-origin: 3.75em 3.75em;\n        border-radius: 7.5em 0 0 7.5em;\n      }\n\n      &[class$='right'] {\n        top: -0.6875em;\n        left: 1.875em;\n        transform: rotate(-45deg);\n        transform-origin: 0 3.75em;\n        border-radius: 0 7.5em 7.5em 0;\n      }\n    }\n\n    .swal2-success-ring {\n      // Ring\n      position: absolute;\n      z-index: 2;\n      top: -0.25em;\n      left: -0.25em;\n      box-sizing: content-box;\n      width: 100%;\n      height: 100%;\n      border: 0.25em solid $swal2-success-border;\n      border-radius: 50%;\n    }\n\n    .swal2-success-fix {\n      // Hide corners left from animation\n      position: absolute;\n      z-index: 1;\n      top: 0.5em;\n      left: 1.625em;\n      width: 0.4375em;\n      height: 5.625em;\n      transform: rotate(-45deg);\n    }\n\n    [class^='swal2-success-line'] {\n      display: block;\n      position: absolute;\n      z-index: 2;\n      height: 0.3125em;\n      border-radius: 0.125em;\n      background-color: $swal2-success;\n\n      &[class$='tip'] {\n        top: 2.875em;\n        left: 0.8125em;\n        width: 1.5625em;\n        transform: rotate(45deg);\n      }\n\n      &[class$='long'] {\n        top: 2.375em;\n        right: 0.5em;\n        width: 2.9375em;\n        transform: rotate(-45deg);\n      }\n    }\n\n    // Success icon animation\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        .swal2-success-line-tip {\n          animation: swal2-animate-success-line-tip 0.75s;\n        }\n\n        .swal2-success-line-long {\n          animation: swal2-animate-success-line-long 0.75s;\n        }\n\n        .swal2-success-circular-line-right {\n          animation: swal2-rotate-success-circular-line 4.25s ease-in;\n        }\n      }\n    }\n  }\n}\n\n// github.com/sweetalert2/sweetalert2/issues/268\n[class^='swal2'] {\n  -webkit-tap-highlight-color: transparent;\n}\n\n.swal2-show {\n  animation: $swal2-show-animation;\n}\n\n.swal2-hide {\n  animation: $swal2-hide-animation;\n}\n\n.swal2-noanimation {\n  transition: none;\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.swal2-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Right-to-left support\n.swal2-rtl {\n  .swal2-close {\n    margin-right: initial;\n    margin-left: $swal2-close-button-gap;\n  }\n\n  .swal2-timer-progress-bar {\n    right: 0;\n    left: auto;\n  }\n}\n\n// TOAST\n.swal2-toast {\n  box-sizing: border-box;\n  grid-column: 1/4 !important;\n  grid-row: 1/4 !important;\n  grid-template-columns: min-content auto min-content;\n  padding: $swal2-toast-padding;\n  overflow-y: hidden;\n  border: $swal2-toast-border;\n  background: $swal2-toast-background;\n  box-shadow: $swal2-toast-box-shadow;\n  pointer-events: all;\n\n  > * {\n    grid-column: 2;\n  }\n\n  h2:where(.swal2-title) {\n    margin: $swal2-toast-title-margin;\n    padding: $swal2-toast-title-padding;\n    font-size: $swal2-toast-title-font-size;\n    text-align: initial;\n  }\n\n  .swal2-loading {\n    justify-content: center;\n  }\n\n  input:where(.swal2-input) {\n    height: $swal2-toast-input-height;\n    margin: $swal2-toast-input-margin;\n    font-size: $swal2-toast-input-font-size;\n  }\n\n  .swal2-validation-message {\n    font-size: $swal2-toast-validation-font-size;\n  }\n\n  div:where(.swal2-footer) {\n    margin: $swal2-toast-footer-margin;\n    padding: $swal2-toast-footer-margin;\n    font-size: $swal2-toast-footer-font-size;\n  }\n\n  button:where(.swal2-close) {\n    grid-column: 3/3;\n    grid-row: 1/99;\n    align-self: center;\n    width: $swal2-toast-close-button-width;\n    height: $swal2-toast-close-button-height;\n    margin: $swal2-toast-close-button-margin;\n    font-size: $swal2-toast-close-button-font-size;\n  }\n\n  div:where(.swal2-html-container) {\n    margin: $swal2-toast-html-container-margin;\n    padding: $swal2-toast-html-container-padding;\n    overflow: initial;\n    font-size: $swal2-toast-html-container-font-size;\n    text-align: initial;\n\n    &:empty {\n      padding: 0;\n    }\n  }\n\n  .swal2-loader {\n    grid-column: 1;\n    grid-row: 1/99;\n    align-self: center;\n    width: 2em;\n    height: 2em;\n    margin: 0.25em;\n  }\n\n  .swal2-icon {\n    grid-column: 1;\n    grid-row: 1/99;\n    align-self: center;\n    width: 2em;\n    min-width: 2em;\n    height: 2em;\n    margin: 0 0.5em 0 0;\n\n    .swal2-icon-content {\n      display: flex;\n      align-items: center;\n      font-size: $swal2-toast-icon-font-size;\n      font-weight: bold;\n    }\n\n    &.swal2-success {\n      .swal2-success-ring {\n        width: 2em;\n        height: 2em;\n      }\n    }\n\n    &.swal2-error {\n      [class^='swal2-x-mark-line'] {\n        top: 0.875em;\n        width: 1.375em;\n\n        &[class$='left'] {\n          left: 0.3125em;\n        }\n\n        &[class$='right'] {\n          right: 0.3125em;\n        }\n      }\n    }\n  }\n\n  div:where(.swal2-actions) {\n    justify-content: flex-start;\n    height: auto;\n    margin: 0;\n    margin-top: 0.5em;\n    padding: 0 0.5em;\n  }\n\n  button:where(.swal2-styled) {\n    margin: 0.25em 0.5em;\n    padding: 0.4em 0.6em;\n    font-size: $swal2-toast-buttons-font-size;\n  }\n\n  .swal2-success {\n    border-color: $swal2-success;\n\n    [class^='swal2-success-circular-line'] {\n      // Emulate moving circular line\n      position: absolute;\n      width: 1.6em;\n      height: 3em;\n      border-radius: 50%;\n\n      &[class$='left'] {\n        top: -0.8em;\n        left: -0.5em;\n        transform: rotate(-45deg);\n        transform-origin: 2em 2em;\n        border-radius: 4em 0 0 4em;\n      }\n\n      &[class$='right'] {\n        top: -0.25em;\n        left: 0.9375em;\n        transform-origin: 0 1.5em;\n        border-radius: 0 4em 4em 0;\n      }\n    }\n\n    .swal2-success-ring {\n      width: 2em;\n      height: 2em;\n    }\n\n    .swal2-success-fix {\n      top: 0;\n      left: 0.4375em;\n      width: 0.4375em;\n      height: 2.6875em;\n    }\n\n    [class^='swal2-success-line'] {\n      height: 0.3125em;\n\n      &[class$='tip'] {\n        top: 1.125em;\n        left: 0.1875em;\n        width: 0.75em;\n      }\n\n      &[class$='long'] {\n        top: 0.9375em;\n        right: 0.1875em;\n        width: 1.375em;\n      }\n    }\n\n    @container swal2-popup style(--swal2-icon-animations:true) {\n      &.swal2-icon-show {\n        .swal2-success-line-tip {\n          animation: swal2-toast-animate-success-line-tip 0.75s;\n        }\n\n        .swal2-success-line-long {\n          animation: swal2-toast-animate-success-line-long 0.75s;\n        }\n      }\n    }\n  }\n\n  &.swal2-show {\n    animation: $swal2-toast-show-animation;\n  }\n\n  &.swal2-hide {\n    animation: $swal2-toast-hide-animation;\n  }\n}\n\n//////////////////////////////\n// ANIMATIONS\n// Appearance animation\n@keyframes swal2-show {\n  0% {\n    transform: scale(0.7);\n  }\n\n  45% {\n    transform: scale(1.05);\n  }\n\n  80% {\n    transform: scale(0.95);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n// Disppearance animation\n@keyframes swal2-hide {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n}\n\n// Success icon animations\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: 0.0625em;\n    width: 0;\n  }\n\n  54% {\n    top: 1.0625em;\n    left: 0.125em;\n    width: 0;\n  }\n\n  70% {\n    top: 2.1875em;\n    left: -0.375em;\n    width: 3.125em;\n  }\n\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em;\n  }\n\n  100% {\n    top: 2.8125em;\n    left: 0.8125em;\n    width: 1.5625em;\n  }\n}\n\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em;\n  }\n\n  100% {\n    top: 2.375em;\n    right: 0.5em;\n    width: 2.9375em;\n  }\n}\n\n@keyframes swal2-rotate-success-circular-line {\n  0% {\n    transform: rotate(-45deg);\n  }\n\n  5% {\n    transform: rotate(-45deg);\n  }\n\n  12% {\n    transform: rotate(-405deg);\n  }\n\n  100% {\n    transform: rotate(-405deg);\n  }\n}\n\n// Error icon animations\n@keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n\n  50% {\n    margin-top: 1.625em;\n    transform: scale(0.4);\n    opacity: 0;\n  }\n\n  80% {\n    margin-top: -0.375em;\n    transform: scale(1.15);\n  }\n\n  100% {\n    margin-top: 0;\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes swal2-animate-error-icon {\n  0% {\n    transform: rotateX(100deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes swal2-rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// Question mark animation\n@keyframes swal2-animate-question-mark {\n  0% {\n    transform: rotateY(-360deg);\n  }\n\n  100% {\n    transform: rotateY(0);\n  }\n}\n\n// Info and Warning mark animation\n@keyframes swal2-animate-i-mark {\n  0% {\n    transform: rotateZ(45deg);\n    opacity: 0;\n  }\n\n  25% {\n    transform: rotateZ(-25deg);\n    opacity: 0.4;\n  }\n\n  50% {\n    transform: rotateZ(15deg);\n    opacity: 0.8;\n  }\n\n  75% {\n    transform: rotateZ(-5deg);\n    opacity: 1;\n  }\n\n  100% {\n    transform: rotateX(0);\n    opacity: 1;\n  }\n}\n\n//////////////////////////////\n// TOAST ANIMATIONS\n@keyframes swal2-toast-show {\n  0% {\n    transform: translateY(-0.625em) rotateZ(2deg);\n  }\n\n  33% {\n    transform: translateY(0) rotateZ(-2deg);\n  }\n\n  66% {\n    transform: translateY(0.3125em) rotateZ(2deg);\n  }\n\n  100% {\n    transform: translateY(0) rotateZ(0deg);\n  }\n}\n\n@keyframes swal2-toast-hide {\n  100% {\n    transform: rotateZ(1deg);\n    opacity: 0;\n  }\n}\n\n@keyframes swal2-toast-animate-success-line-tip {\n  0% {\n    top: 0.5625em;\n    left: 0.0625em;\n    width: 0;\n  }\n\n  54% {\n    top: 0.125em;\n    left: 0.125em;\n    width: 0;\n  }\n\n  70% {\n    top: 0.625em;\n    left: -0.25em;\n    width: 1.625em;\n  }\n\n  84% {\n    top: 1.0625em;\n    left: 0.75em;\n    width: 0.5em;\n  }\n\n  100% {\n    top: 1.125em;\n    left: 0.1875em;\n    width: 0.75em;\n  }\n}\n\n@keyframes swal2-toast-animate-success-line-long {\n  0% {\n    top: 1.625em;\n    right: 1.375em;\n    width: 0;\n  }\n\n  65% {\n    top: 1.25em;\n    right: 0.9375em;\n    width: 0;\n  }\n\n  84% {\n    top: 0.9375em;\n    right: 0;\n    width: 1.125em;\n  }\n\n  100% {\n    top: 0.9375em;\n    right: 0.1875em;\n    width: 1.375em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
